import { LichSuXuatKhoComponent } from "./../lich-su-xuat-kho/lich-su-xuat-kho.component";
import { ChiTietSoLuongTonPageComponent } from "../chi-tiet-so-luong-ton-page/chi-tiet-so-luong-ton-page.component";
import { element } from "protractor";
import { TimKiemNangCaoListComponent } from "../../../../tim-kiem-nang-cao/tim-kiem-nang-cao.component";
import { FunctionPublic } from "../../../dung-chung/__function/common_function";
import { DeNghiMuaHangService } from "../../../mua-hang/de-nghi-mua-hang/de-nghi-mua-hang-service/de-nghi-mua-hang.service";
import {
	Component,
	OnInit,
	ElementRef,
	ViewChildren,
	ViewChild,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Inject,
	HostListener,
	ViewRef,
	Optional,
} from "@angular/core";
import { DatePipe } from "@angular/common";
// Material
import {
	MatMenuTrigger,
	MatDialogRef,
	MAT_DIALOG_DATA,
	MatDialog,
	MatTabChangeEvent,
} from "@angular/material";
import { SelectionModel } from "@angular/cdk/collections";
import {
	CdkDragStart,
	CdkDropList,
	moveItemInArray,
} from "@angular/cdk/drag-drop";
// RXJS
import { ReplaySubject, BehaviorSubject, Subject } from "rxjs";
//Service
import { KhoDeNghiXuatKhoPageService } from "../kho-de-nghi-xuat-kho-page-service/kho-de-nghi-xuat-kho-page.service";
import { DungChungService } from "../../../dung-chung/__services/dung-chung.service";

import { SubheaderService } from "../../../../../../core/_base/layout";
import {
	LayoutUtilsService,
	QueryParamsModel,
} from "../../../../../../core/_base/crud";
import { TokenStorage } from "../../../../../../core/auth/_services/token-storage.service";
//Model
import {
	CONFIGURATION,
	DEFAULT,
	ERROR_MESSAGES,
	KhoDeNghiXuatKhoPage,
	KhoDeNghiXuatKhoPageChiTiet,
	SUCCESS,
} from "../kho-de-nghi-xuat-kho-page-model/kho-de-nghi-xuat-kho-page.model";

import { CommonConFig } from "../../../dung-chung/__model/common_config.model";
import {
	FormGroup,
	FormBuilder,
	Validators,
	AbstractControl,
	ValidationErrors,
} from "@angular/forms";
import moment from "moment";
import { ActivatedRoute, Router } from "@angular/router";
import { debug, error } from "console";
import { ListDonHangBanCtComponent } from "../list-don-hang-ban-ct/list-don-hang-ban-ct.component";
import { KhKeHoachSanXuatDuKienNhapXuatInteraction } from "../../../san-xuat/ke-hoach-san-xuat/ke-hoach-san-xuat-model/ke-hoach-san-xuat.model";
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { LoaiPhieuService } from "../../../danh-muc/loai-phieu/loai-phieu-service/loai-phieu.service";
import { NhapQuyTrinhDuyetService } from "../../../quy-trinh/nhap-quy-trinh-duyet/Services/nhap-quy-trinh-duyet.service";
import { truncate } from "lodash";

@Component({
	selector: "m-kho-de-nghi-xuat-kho-page-edit",
	templateUrl: "./kho-de-nghi-xuat-kho-page-edit.component.html",
	styleUrls: ["../kho-de-nghi-xuat-kho-page.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe],
})
export class KhoDeNghiXuatKhoPageEditComponent implements OnInit {
	//#region Config
	CONFIG: CommonConFig;
	FUNCTION: FunctionPublic;
	//#endregion Config

	/*------------------------ Danh sách ĐVT -----------------------------*/
	listDVT: any[] = [];
	selectListDVT: string = '';
	filteredListDVT: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListDVTFilterCtrl: string = '';
	haveElementListDVT: boolean = false;
	textQuiDoiDVT = '';
	soLuongDaQuiDoi = 0;
	soLuong = 0;
	/* ------------------------------------------------------------------ */

	//#region Các trường focus cho các tag trong form
	@ViewChildren("focusGhiChu") focusGhiChu;
	@ViewChildren("focusSoPhieuDHB") focusSoPhieuDHB;
	@ViewChildren("focusSL") focusSL;
	@ViewChildren("focusDetail") focusDetail;
	@ViewChild("focusDetail", { static: true }) focusDetailValue: ElementRef;
	@ViewChild("fileUploadImport", { static: false }) fileUploadImport: ElementRef;
	@ViewChildren("otherReason") otherReason;
	@ViewChildren("contentChungTu") contentChungTu;
	/* Trigger menu hiển thị cột cho danh sách */
	@ViewChild("trigger", { static: true }) _trigger: MatMenuTrigger;
	//#endregion Các trường focus cho các tag trong form

	//#region Column Table
	displayedColumns = [];
	availableColumns = DEFAULT.TABLE_COLUMNS;
	extendColumn = DEFAULT.TABLE_EXTEND_COLUMNS;
	sumColums: string[] = ['#', 'SOLUONG', 'SOLUONGTHUCXUAT'];

	//#endregion Column Table

	//#region  Mat Select
	/* Mat select search cho khach hang */
	listListBP: any[] = [];
	selectListBP: string = "";
	filteredListBP: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListBPFilterCtrl: string = "";
	haveElementListBP: boolean = false;
	public dataTree: BehaviorSubject<any[]> = new BehaviorSubject([]);

	listListBP2: any[] = [];
	selectListBP2: string = "";
	filteredListBP2: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListBP2FilterCtrl: string = "";
	haveElementListBP2: boolean = false;
	/* ------------------------------------------------------------------ */
	/* ------------------------------- Danh sách khách hàng ----------------------------------- */
	listId_KH: any[] = [];
	selectedId_KH: number = 0;
	filteredId_KH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	sumRecord_KH = 0;
	arrayKHForEachHH: any[] = [];
	KHFilterCtrl: string = '';
	/* Mat select search cho khach hang */
	listListSPDHB: any[] = [];
	selectListSPDHB: string = "";
	filteredListSPDHB: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListSPDHBFilterCtrl: string = "";
	haveElementListSPDHB: boolean = false;
	// .. Danh sách NCC
	suppliers: any[] = [];
	selectedSupplierId: number = 0;
	filteredSuppliers: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	sumSuppliers = 0;
	supplierFilterCtrl: string = '';
	seachSupplier: Subject<string> = new Subject<string>();
	/* ------------------------------------------------------------------ */

	/* Mat select search cho hàng hóa */
	listId_HH: any[] = [];
	selectId_HH: string = "";
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	sumRecord = 0;
	Id_HHFilterCtrl: string = "";
	haveElementId_HH: boolean = false;
	/* ------------------------------------------------------------------ */
	//#endregion Mat Select

	//#region Khai báo biến
	/* Giá trị đầu tiên cho dropdown quyết định nhập hàng - Form QC kiểm tra*/
	processImport: boolean = true; // Có đang chạy import
	/* ------------------------------------------------------------------ */

	/* Selection */
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<KhoDeNghiXuatKhoPageChiTiet>(true, []);
	/* ------------------------------------------------------------------ */

	/* Loading.... */
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */

	/* Extend field:  */
	previousIndex: number; // Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2; // Số chữ số phần thập phân cho kiểu dữ liệu số.
	isChange: boolean = false; // Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	isZoomSize: boolean = false; // Trường đánh dấu có đang ở trạng thái zoom size hay không
	saveAddedTTHV: number[] = []; // Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	viewLoading: boolean = true; // Loading khi mở dialog
	isCopy: boolean = false; // Dialog có thể chỉnh sửa không?
	/* ------------------------------------------------------------------ */

	/* Các Sub form trên dialog:  */
	KhoDeNghiXuatKhoForm: FormGroup; //Form phiếu đề nghị
	hasFormErrors: boolean = false;

	KhoDeNghiXuatKhoSubForm: FormGroup; //Form phiếu đề nghị
	hasSubFormErrors: boolean = false;

	ImportHHForm: FormGroup;
	/* ------------------------------------------------------------------ */

	/* Item dữ liệu từ của phiếu đề nghị khi mở dialog:  */
	KhoDeNghiXuatKhoItem: KhoDeNghiXuatKhoPage;

	/* Danh sách tạm chi tiết hàng hóa của phiếu đề nghị dùng để cập nhập trên lưới  */
	tmpChiTietKhoDeNghiXuatKho: KhoDeNghiXuatKhoPageChiTiet[] = [];

	/* Danh sách tình trạng phiếu */
	Tinhtrang = DEFAULT.LIST_STATUS;

	openTimKiemNangCao = false;
	typeOptions: any[] = [];

	openDHB: boolean = false;

	openKHGH: boolean = false;

	flagChangeLoaiPhieu = "";

	idPBMacDinhFromSX = 0;
	isFromKHSX: boolean = false;
	listResultNPL: KhKeHoachSanXuatDuKienNhapXuatInteraction[] = [];

	spinnerHH: boolean = false;
	isFromLSX: boolean = false;
	fromBOM: boolean = false;
	isFromNLSX: boolean = false;
	dataFromBOM: any[] = [];
	progressBar = new BehaviorSubject<boolean>(false);
	loadingDownloadTemplate = new BehaviorSubject<boolean>(false);
	loadingImportFile = new BehaviorSubject<boolean>(false);
	rowUpdate: number = -1;
	idCusBeforeAmended: number = -1;
	activatedRoute: ActivatedRoute;
	//#endregion Khai báo biến

	//#region Phím tắt nhanh
	@HostListener("window:keyup", ["$event"])
	keyEvent(event: KeyboardEvent): void {
		if (!this.processImport && !this.viewLoading) {
			const keyCode = event.keyCode;
			const altKey = event.altKey;

			switch (keyCode) {
				case this.CONFIG.BUTTON_FORM.BACK.KeyCombine.keycode:
					if (!this.openTimKiemNangCao) {
						this.back(true);
					}
					break;
				case this.CONFIG.BUTTON_FORM.SAVE.KeyCombine.keycode:
					if (altKey) {
						this.onSubmit(1);
					}
					break;
				case this.CONFIG.BUTTON_FORM.SAVE_AND_NEW.KeyCombine.keycode:
					if (altKey) {
						this.onSubmit(2);
					}
					break;
				case this.CONFIG.BUTTON_FORM.SAVE_TMP.KeyCombine.keycode:
					if (altKey) {
						this.onSubmit(0);
					}
					break;
			}
		}
	}
	//#endregion Phím tắt nhanh
	listMachineCode: string[] = [];
	keywordChanged: Subject<string> = new Subject<string>();
	loadingMerchandise = new BehaviorSubject<boolean>(false);
	fakeOptionNumber: number = 5;

	/*--< Khai báo biến cho dropdown Bộ phận sử dụng >--*/
	listBP: any[] = [];
	selectBP: string = '';
	filteredBP: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	BPFilterCtrl: string = '';
	/* ------------------------------------------------------------------ */

	// .. Biến cho dialog form
	isPageForm = new BehaviorSubject<boolean>(true);
	// ........................

	// .. Mat select đối tượng THCP
	listObjTHCP: any[] = [];
	selectObjTHCP: string = "";
	filteredObjTHCP: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	objTHCPFilterCtrl: string = "";
	haveElementObjTHCP: boolean = false;
	searchObjTHCP: Subject<string> = new Subject<string>();
	loadingObjTHCP = new BehaviorSubject<boolean>(false);
	requireDivisionInUse = new BehaviorSubject<boolean>(false);
	requireDepartmentInUse = new BehaviorSubject<boolean>(false);
	// ............................
	// .. Dropdown reasons
	arrReason = []
	orgStructureTree: any[] = [];
	optionsDivision:  any[] = [];
	// .. Variables list
	batchQuantityList: string[] = [];
	manufacturingDateList: any[] = [];
	expirationDateList: any[] = [];
	containerCodeList: string[] = [];
	// ............................
	sltRequestDepartment: string = "";
	ftrRequestDepartment: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	requestDepartmentFtrCtrl: string = '';
	sltUsingDepartment: string = "";
	ftrUsingDepartment: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	usingDepartmentFtrCtrl: string = '';
	sltUsingDivision: string = "";
	ftrUsingDivision: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	usingDivisionFtrCtrl: string = '';
	notCheckChange = CONFIGURATION.NOT_CHECK_CHANGE;
	closePopup = CONFIGURATION.CLOSE_POPUP;
	//#region  Constructor
	constructor(
		@Optional() public dialogRef: MatDialogRef<KhoDeNghiXuatKhoPageEditComponent>,
		@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
		private KhoDeNghiXuatKhoService: KhoDeNghiXuatKhoPageService,
		private commonService: DungChungService,
		public dialog: MatDialog,
		private KhoDeNghiXuatKhoFB: FormBuilder,
		private route: ActivatedRoute,
		private KhoDeNghiXuatKhoSubFB: FormBuilder,
		private ImportHHFB: FormBuilder,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private subheaderService: SubheaderService,
		private el: ElementRef,
		private deNghiMuaHangService: DeNghiMuaHangService,
		private router: Router,
		private loaiPhieuService: LoaiPhieuService,
		private _dynamicSequence: NhapQuyTrinhDuyetService,
	) {
		// ------ Hàm làm mới danh sách hàng hóa mỗi khi search
		if (this.keywordChanged) {
			this.keywordChanged
				.pipe(
					debounceTime(500),
					distinctUntilChanged()
				)
				.subscribe(value => {
					this.ListId_HH(value);
				});
		}
		this.searchObjTHCP.pipe(debounceTime(500), distinctUntilChanged())
			.subscribe(res => { this.ListObjTHCP(res); });
	}
	//#endregion Constructor

	//#region Load Data
	async ngOnInit() {
		this.viewLoading = false;
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.FUNCTION = new FunctionPublic(this.commonService);

		/*Get data from list when open dialog */
		this.KhoDeNghiXuatKhoItem = new KhoDeNghiXuatKhoPage();
		this.KhoDeNghiXuatKhoItem.clear();

		// .. Load all dropdown and create form
		this.initializeData();

		// .. Xử lý dialog
		if (this.data != null && this.data.data != null)
			this.handleFormDialog();
		// .................................................
		// .. Xử lý page
		if (!this.data) {
			const form = this.KhoDeNghiXuatKhoForm;
			const subForm = this.KhoDeNghiXuatKhoSubForm;
			var data = window.history.state;
			if (data != null && data.isFromKHSX) {
				this.isFromKHSX = true;
				this.listResultNPL = data.data;
			}

			// .. Thêm đề nghị xuất kho từ BOM
			if (data != null && data.fromBOM) {
				this.fromBOM = true;
				this.dataFromBOM = data.data;
			}

			subForm.get("MAHH")
				.valueChanges
				.subscribe(keyWords => {
					this.filterId_HH(keyWords);
				});
			form.get('MaKhachHang')
				.valueChanges
				.subscribe(keyWords => {
					this.filterId_KH('' + keyWords);
				})
			form.get('SUPPLIER_CODE')
				.valueChanges
				.subscribe(keyWords => {
					this.searchSupplier('' + keyWords);
				})
			this.route.params.subscribe((params) => {
				const id = +params.id;
				const arrUrl = this.router.url.split("/");
				const url = arrUrl[arrUrl.length - 2];
				if (url == "chinh-sua" && id && id > 0) {
					//this.viewLoading = true;
					let breadcrumbs = [
						{ title: "Kho" },
						{ title: "Đề nghị xuất kho", page: "/de-nghi-xuat-kho" },
						{
							title: "Chỉnh sửa",
							page: "/de-nghi-xuat-kho/chinh-sua/" + id,
						},
					];
					this.subheaderService.setBreadcrumbs(breadcrumbs);
					this.KhoDeNghiXuatKhoService.detail(id).subscribe((res) => {
						if (
							!res ||
							res.status == 0 ||
							res.data.Tinhtrang != "KHOPDNXK_LUUNHAP"
						) {
							this.router.navigateByUrl("/404");
						} else if (res && res.status == 1) {
							this.KhoDeNghiXuatKhoItem = res.data;
							const form = this.KhoDeNghiXuatKhoForm.controls;
							const detail = this.KhoDeNghiXuatKhoItem;
							if (this.KhoDeNghiXuatKhoForm != null) {
								this.KhoDeNghiXuatKhoItem.IdDn = id;
								form["SOPHIEU"].setValue(detail.Sophieu);
								form["NGAYLAP"].setValue(detail.Ngaytao);
								form["NGUOILAP"].setValue(detail.TenNguoitao);
								form["DESCTRANGTHAI"].setValue(detail.DescTinhTrang);
								form["LOAIPHIEU"].setValue("" + detail.LoaiPhieu);
								form["GHICHU"].setValue("" + detail.Ghichu);
								form["CHUNGTUKEMTHEO"].setValue(res.data.ChungTuKemTheo);
								form["TENSOCHUNGTU"].setValue(res.data.TenSoChungTu);
								// .. Xử lý lý do xuất
								if (!detail.Lydocode) {
									form['LYDOXUAT'].setValue(CONFIGURATION.OTHER_REASONS.key);
									form['LYDOKHAC'].setValue(detail.Lydo);
								}
								else
									form['LYDOXUAT'].setValue(detail.Lydocode);
								this.changeTypeOfVote("" + detail.LoaiPhieu);
								this.tmpChiTietKhoDeNghiXuatKho = [];
								for (
									let i = 0;
									i < this.KhoDeNghiXuatKhoItem.ChiTiet.length;
									i++
								) {
									let tmpElement = new KhoDeNghiXuatKhoPageChiTiet();
									tmpElement.copy(this.KhoDeNghiXuatKhoItem.ChiTiet[i]);
									tmpElement.SoMayArr 	= tmpElement.SoMay.split(",").map(x => x.toString().trim());
									tmpElement.SXSMArr 		= tmpElement.SXSM.split(",").map(x => x.toString().trim());
									tmpElement.NSXArr 		= tmpElement.NSX.split(",").map(x => x.toString().trim());
									tmpElement.HSDArr 		= tmpElement.HSD.split(",").map(x => x.toString().trim());
									tmpElement.MaThungArr 	= tmpElement.MaThung.split(",").map(x => x.toString().trim());
									tmpElement.searchNewPSD = "";
									tmpElement.listNewBPSD 	= this.listBP;
									this.tmpChiTietKhoDeNghiXuatKho.push(tmpElement);
								}
								this.tmpChiTietKhoDeNghiXuatKho = [
									...this.tmpChiTietKhoDeNghiXuatKho,
								];
								this.loadOptionsDropdownForDetails();
								this.changeDetect.detectChanges();
							}
						}
					});
				} else {
					let breadcrumbs = [
						{ title: "Kho" },
						{ title: "Đề nghị xuất kho", page: "/de-nghi-xuat-kho" },
						{ title: "Thêm mới", page: "/de-nghi-xuat-kho/them-moi" },
					];
					this.subheaderService.setBreadcrumbs(breadcrumbs);
					var tenNguoiLap = "";
					this.tokenStorage.getFullName().subscribe((t) => {
						tenNguoiLap = t;
					});
					this.KhoDeNghiXuatKhoForm.controls["NGUOILAP"].setValue(
						tenNguoiLap
					);
					this.createBillNumber().then((r) => {
						this.KhoDeNghiXuatKhoForm.controls["SOPHIEU"].setValue(r);
					});

					if (url == "them-moi" && id && id > 0) {
						this.KhoDeNghiXuatKhoService.detail(id).subscribe((res) => {
							if (!res || res.status == 0) {
								this.router.navigateByUrl("/404");
							} else if (res && res.status == 1) {
								if (this.KhoDeNghiXuatKhoForm != null) {
									const COPY_DATA = true;
									const form = this.KhoDeNghiXuatKhoForm.controls;
									form["LOAIPHIEU"].setValue("" + res.data.LoaiPhieu);
									form["GHICHU"].setValue(res.data.Ghichu);
									form["GHICHU"].setValue(res.data.Ghichu);
									form["CHUNGTUKEMTHEO"].setValue(res.data.ChungTuKemTheo);
									form["TENSOCHUNGTU"].setValue(res.data.TenSoChungTu);
									// .. Xử lý lý do xuất
									if (!res.data.Lydocode) {
										form['LYDOXUAT'].setValue(CONFIGURATION.OTHER_REASONS.key);
										form['LYDOKHAC'].setValue(res.data.Lydo);
									}
									else
										form['LYDOXUAT'].setValue(res.data.Lydocode);
									this.tmpChiTietKhoDeNghiXuatKho = [];
									for (let i = 0; i < res.data.ChiTiet.length; i++) {
										let filterTmp 			= new ReplaySubject<any[]>(1)
										let tmpElement 			= new KhoDeNghiXuatKhoPageChiTiet();

										tmpElement.copy(res.data.ChiTiet[i]);
										tmpElement.SoMayArr 	= tmpElement.SoMay.split(",").map(x => x.toString().trim());
										tmpElement.SXSMArr 		= tmpElement.SXSM.split(",").map(x => x.toString().trim());
										tmpElement.NSXArr 		= tmpElement.NSX.split(",").map(x => x.toString().trim());
										tmpElement.HSDArr 		= tmpElement.HSD.split(",").map(x => x.toString().trim());
										tmpElement.MaThungArr 	= tmpElement.MaThung.split(",").map(x => x.toString().trim());
										tmpElement.searchNewPSD = "";
										tmpElement.listNewBPSD 	= this.listBP;

										filterTmp.next(this.listId_KH.slice());
										this.arrayKHForEachHH.push(filterTmp);
										this.tmpChiTietKhoDeNghiXuatKho.push(tmpElement);
									}
									this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho,];
									this.loadOptionsDropdownForDetails(COPY_DATA);
								}
							}
						});
					} else if (this.isFromKHSX) {
						this.listResultNPL.forEach((x) => {
							let item = new KhoDeNghiXuatKhoPageChiTiet();
							item.IdHh = x.HangHoaId;
							this.listId_HH.forEach((el) => {
								if (item.IdHh == el.Id_HH) {
									item.MaHH = el.MaHH;
									item.TenHH = el.TenHH;
									item.QuyCach = el.QuyCach;
								}
							});
							item.Dvt = x.Dvt;
							item.TenDvt = x.TenDVTNPL;
							item.Soluong = x.DuKienXuat;
							item.NgayCan = x.NgaySanXuat;
							item.MucDichSuDung = "Xuất hàng sản xuất";
							item.BPDN = this.idPBMacDinhFromSX;
							item.BPSD = this.idPBMacDinhFromSX;
							item.SoLo = "";
							item.SoMay = "";
							item.SLThucXuat = 0.0;
							item.IsChoPassKhan = x.FlagPassKhan;
							item.NguonPhatSinhId = x.DatHangCtId;

							this.listListBP.forEach((bp) => {
								if (bp.Id_PB == item.BPDN) item.TenBPDN = bp.TenPB;
								if (bp.Id_PB == item.BPSD) item.TenBPSD = bp.TenPB;
							});
							this.listListSPDHB.forEach((el) => {
								if (el.Id == item.DatHangId)
									item.DatHangSoPhieu = el.SoPhieu;
							});
							this.tmpChiTietKhoDeNghiXuatKho.push(item);
						});
						let tmp = this.tmpChiTietKhoDeNghiXuatKho;
						this.tmpChiTietKhoDeNghiXuatKho = [...tmp];
						this.changeDetect.detectChanges();
					} else if (this.fromBOM) {
						this.progressBar.next(true);
						this.bindingFromBOM();
					}
					this.changeDetect.detectChanges();
				}
			});
		}

		this.processImport = false;
		/*Show column */
		this.showColumnsInTable();
		this.applySelectedColumns();
	}

	// .. Main service
	initializeData() {
		this.loadOrganizationStructureTree();
		this.loadListKhachHang()
		this.getIdPBMacDinhFromSanXuat();
		this.createForm();
		this.ListId_HH();
		this.ListObjTHCP();
		this.ListLoaiPhieu();
		this.ListBP();
		this.ListSPDHB();
		this.ListDVT();
		this.loadAllSuppliers();
		this.listReasonsWarehouse();
	}

	ngAfterViewInit() {
		//this.changeDetect.detectChanges();
	}

	ngOnDestroy() {
		this.clearDataImport();
	}

	ListLoaiPhieu() {
		const form = this.KhoDeNghiXuatKhoForm.controls;
		const data = this.KhoDeNghiXuatKhoItem;
		const id = 1;

		this.commonService.layDanhSachLoaiPhieu(id).subscribe(
			(res) => {
				if (res && res.status == 1) {
					const TICKET_TYPE = "LOAIPHIEU";
					const selectedValue = data.IdDn ? data.LoaiPhieu : res.data[0].Id;

					// .. Lấy dữ liệu và truyền flag
					// this.typeOptions  = res.data.filter((x) => !x.OpenKHGH) || [];
					// .. Mở lại loại phiếu 'Kế hoạch bán hàng'
					this.typeOptions = res.data || [];
					form[TICKET_TYPE].setValue(selectedValue.toString());
					this.flagChangeLoaiPhieu = form[TICKET_TYPE].value.toString();

					// .. Định dạng loại phiếu cho biến openDHB, openKHGH
					if (data.IdDn > 0) {
						this.typeOptions.forEach((x) => {
							if (this.strEquals(x.Id, data.LoaiPhieu)) {
								this.openDHB = x.OpenDHB;
								this.openKHGH = x.OpenKHGH;
							}
						});
					}
					this.changeTypeOfVote(form[TICKET_TYPE].value);
					this.changeDetectView();
				} else {
					const errorMessage = res.error.message || "Lỗi: Không thể lấy danh sách loại phiếu";
					this.layoutUtilsService.showErorr(errorMessage);
				}
			},
			(error) => {
				this.layoutUtilsService.showErorr("Xảy ra lỗi khi lấy danh sách loại phiếu");
			}
		);

	}
	//#endregion Load Data

	//#region Tạo và chỉnh sửa form
	createForm() {
		/*Get name of người lập phiếu */
		var tenNguoiLap = "";
		this.tokenStorage.getFullName().subscribe((t) => { tenNguoiLap = t; });
		const myItem = this.KhoDeNghiXuatKhoItem;
		const validNgayTao = !(myItem.Ngaytao == undefined || myItem.Ngaytao == "");
		const FIELD_EMPTY = "";
		const minDataSL = 0.01;

		// ' Tạo các trường form chính'
		this.KhoDeNghiXuatKhoForm = this.KhoDeNghiXuatKhoFB.group({
			SOPHIEU: [myItem.Sophieu, Validators.required],
			NGAYLAP: [validNgayTao ? myItem.Ngaytao : new Date(), Validators.required,],
			NGUOILAP: [myItem.Nguoitao > 0 ? myItem.TenNguoitao : tenNguoiLap,],
			TRANGTHAI: [myItem.Tinhtrang == "" ? this.Tinhtrang[0].value : myItem.Tinhtrang,],
			DESCTRANGTHAI: [myItem.DescTinhTrang == "" ? this.Tinhtrang[0].name : myItem.DescTinhTrang,],
			LOAIPHIEU: [!myItem.LoaiPhieu ? "" : "" + myItem.LoaiPhieu, Validators.required,],
			GHICHU: [!myItem.Ghichu ? "" : "" + myItem.Ghichu, Validators.required,],
			MaKhachHang: [FIELD_EMPTY],
			TenKhachHang: [FIELD_EMPTY],
			LYDOXUAT: [FIELD_EMPTY, Validators.required],
			LYDOKHAC: [FIELD_EMPTY],
			CHUNGTUKEMTHEO: [FIELD_EMPTY],
			TENSOCHUNGTU: [FIELD_EMPTY],
			SUPPLIER_CODE: [FIELD_EMPTY],
			SUPPLIER_NAME: [FIELD_EMPTY],
			RECEIVER_NAME: [FIELD_EMPTY],
			ADDRESS_RECEIVE_PRODUCT: [FIELD_EMPTY]
		});

		// ' Tạo các trường sub form '
		this.KhoDeNghiXuatKhoSubForm = this.KhoDeNghiXuatKhoSubFB.group({
			MAHH: [FIELD_EMPTY, Validators.required],
			TENHH: [FIELD_EMPTY],
			QUYCACH: [FIELD_EMPTY],
			DVTQuiDoi: [FIELD_EMPTY, Validators.required],
			SoLuongQuiDoi: [FunctionPublic.TEXT_MIN_POINT,
			Validators.compose([
				Validators.required,
				Validators.maxLength(24),
				this.minValidator(0.00001)
			]),
			],
			SLTON: [FunctionPublic.TEXT_MIN_POINT,
			Validators.compose([
				Validators.pattern(
					this.CONFIG.REGEX_FORMAT_NUMBER_NOTREQUIRED
				),
			]),
			],
			NGAYCAN: [new Date(), Validators.required],
			MUCDICHSUDUNG: [FIELD_EMPTY],
			BPDN: [FIELD_EMPTY, Validators.required],
			BPSD: [FIELD_EMPTY],
			SOLO: [FIELD_EMPTY],
			SOMAY: [FIELD_EMPTY],
			DIVISION: [FIELD_EMPTY],
			OBJTHCP: [FIELD_EMPTY],
			SOMEXE: [FIELD_EMPTY],
			NSX: [FIELD_EMPTY],
			HSD: [FIELD_EMPTY],
			MATHUNG: [FIELD_EMPTY],
		});

		// ' Tạo các trường upload dữ liệu '
		this.ImportHHForm = this.ImportHHFB.group({ FileDuLieu: [FIELD_EMPTY], });

		// ' Tạo biến change loại phiếu '
		if (myItem.IdDn > 0)
			this.flagChangeLoaiPhieu = myItem.LoaiPhieu.toString();

		const form = this.KhoDeNghiXuatKhoForm.controls;
		const subForm = this.KhoDeNghiXuatKhoSubForm.controls;

		// .. Disable master form
		form["SOPHIEU"].disable();
		form["NGUOILAP"].disable();
		form["NGAYLAP"].disable();
		form["DESCTRANGTHAI"].disable();
		form["TenKhachHang"].disable();
		form["SUPPLIER_NAME"].disable();

		// .. Disable detail form
		subForm["TENHH"].disable();
		subForm["QUYCACH"].disable();
		subForm["SLTON"].disable();
		subForm["OBJTHCP"].disable();
		subForm["SOLO"].disable();
		subForm["SOMAY"].disable();
		subForm["SOMEXE"].disable();
		subForm["NSX"].disable();
		subForm["HSD"].disable();
		subForm["MATHUNG"].disable();
		subForm["DVTQuiDoi"].disable();

		this.tmpChiTietKhoDeNghiXuatKho = myItem.ChiTiet;
		this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];

		// .. Cập nhật các trường bắt buộc cho trường đối tượng THCP
		this.updateRequiredFieldsForObjTHCP();
	}
	//#endregion Tạo và chỉnh sửa form
	afterSelectNewBPSD(value: string) {
		if (this.selectedId_KH == 0) {
			const controls = this.KhoDeNghiXuatKhoForm.controls;
			var item = this.listBP.find(x => x.Id_PB == value);
			if (item != undefined) {
				controls["GHICHU"].setValue("Xuất kho cho " + item.TenPB)
			}
		}
	}
	afterSelectBPSD(value: string) {
		if (this.selectedId_KH == 0 && this.KhoDeNghiXuatKhoSubForm.controls["DIVISION"].value == "") {
			const controls = this.KhoDeNghiXuatKhoForm.controls;
			var item = this.listListBP2.find(x => x.Id_PB == value);
			if (item != undefined) {
				controls["GHICHU"].setValue("Xuất kho cho " + item.TenPB)
			}
		}
	}
	//#region Lấy tiều đề
	getTitle(): string {
		if (this.KhoDeNghiXuatKhoItem.IdDn > 0)
			return `CHỈNH SỬA PHIẾU ĐỀ NGHỊ XUẤT KHO`;
		return `THÊM MỚI PHIẾU ĐỀ NGHỊ XUẤT KHO `;
	}
	//#endregion Lấy tiêu đề

	//#region Thao tác thêm hàng, xóa hàng
	addHang() {
		const subForm = this.KhoDeNghiXuatKhoSubForm;
		const subFormControl = subForm.controls;

		// ... Validate sub form
		if (!this.subFormValidation()) return;
		// ... Fill data
		var item = new KhoDeNghiXuatKhoPageChiTiet();
		item = this.mapFormControlDataToItem();
		// -------------- Thêm vào danh sách --------------------------
		let flag = true;
		this.tmpChiTietKhoDeNghiXuatKho.forEach((e, index) => {
			if (index != this.rowUpdate) {
				e.SoLuongQuiDoi = Number(e.SoLuongQuiDoi);
				e.Soluong = Number(e.Soluong);
				//----------------- Đã tồn tại -----------------------
				if (e.IdHh == item.IdHh && e.DvtQuiDoi == item.DvtQuiDoi) {
					if (!this.openDHB) {
						if (
							e.BPSD == item.BPSD &&
							e.NewBPSD == item.NewBPSD &&
							e.BPDN == item.BPDN &&
							e.SoMay == item.SoMay &&
							e.SoLo == item.SoLo &&
							item.NgayCan == e.NgayCan
						) {
							e.SoLuongQuiDoi += Number(item.SoLuongQuiDoi);
							e.Soluong += Number(item.Soluong);
							e.TextQuiDoiDVT = e.Soluong + ',00 ' + (item.ListHH ? item.ListHH[0].TenDVT : '');
							e.MucDichSuDung += ", " + item.MucDichSuDung;
							if (item.GhiChu) e.GhiChu += ", " + item.GhiChu;
							flag = false;
						}
					}
					if (this.openDHB) {
						if (item.DatHangId) {
							if (
								e.DatHangId == item.DatHangId &&
								e.BPDN == item.BPDN &&
								e.BPSD == item.BPSD &&
								e.NewBPSD == item.NewBPSD &&
								e.SoMay == item.SoMay &&
								e.SoLo == item.SoLo &&
								item.NgayCan == e.NgayCan
							) {
								e.SoLuongQuiDoi += Number(item.SoLuongQuiDoi);
								e.Soluong += Number(item.Soluong);
								e.TextQuiDoiDVT = e.Soluong + ',00 ' + (item.ListHH ? item.ListHH[0].TenDVT : '');
								e.MucDichSuDung += ", " + item.MucDichSuDung;
								if (item.GhiChu) e.GhiChu += ", " + item.GhiChu;
								flag = false;
							}
						} else {
							if (
								!e.DatHangId &&
								e.BPDN == item.BPDN &&
								e.BPSD == item.BPSD &&
								e.NewBPSD == item.NewBPSD &&
								e.SoMay == item.SoMay &&
								e.SoLo == item.SoLo &&
								item.NgayCan == e.NgayCan
							) {
								e.SoLuongQuiDoi += Number(item.SoLuongQuiDoi);
								e.Soluong += Number(item.Soluong);
								e.TextQuiDoiDVT = e.Soluong + ',00 ' + (item.ListHH ? item.ListHH[0].TenDVT : '');
								e.MucDichSuDung += ", " + item.MucDichSuDung;
								if (item.GhiChu) e.GhiChu += ", " + item.GhiChu;
								flag = false;
							}
						}
					}
				}
			}
		});

		if (flag) {
			item.searchNewPSD = "";
			item.listNewBPSD = this.listBP;
			let filterTmp = new ReplaySubject<any[]>(1)
			filterTmp.next(this.listId_KH.slice());
			this.arrayKHForEachHH.push(filterTmp);
			if (this.rowUpdate < 0) this.tmpChiTietKhoDeNghiXuatKho.push(item);
		}
		if (this.rowUpdate >= 0) {
			this.updateDataRow(item);
			this.rowUpdate = -1;
		}
		let tmp = this.tmpChiTietKhoDeNghiXuatKho;
		this.bindValueDienGiai();
		this.resetSubForm();
		this.textQuiDoiDVT = '';
		this.soLuong = 0;
		this.tmpChiTietKhoDeNghiXuatKho = [...tmp];
		this.changeDetect.detectChanges();
	}

	deleteItem(item: any) {
		let index = this.tmpChiTietKhoDeNghiXuatKho.indexOf(item, 0);
		if (index > -1) {
			this.tmpChiTietKhoDeNghiXuatKho.splice(index, 1);
			this.arrayKHForEachHH.splice(index, 1);
			this.bindValueDienGiai();
		}
		this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];
	}

	deleteHang(item: any) {
		const dialogRef = this.layoutUtilsService.POP01_DanhMuc();
		dialogRef.afterClosed().subscribe((res) => {
			if (!res) return;
			const index = this.tmpChiTietKhoDeNghiXuatKho.indexOf(item, 0);
			if (index > -1) {
				this.tmpChiTietKhoDeNghiXuatKho.splice(index, 1);
				this.arrayKHForEachHH.splice(index, 1);
				this.bindValueDienGiai();
				if (index < this.rowUpdate && this.rowUpdate > -1) this.rowUpdate -= 1;
			}
			let tmp = this.tmpChiTietKhoDeNghiXuatKho;
			this.tmpChiTietKhoDeNghiXuatKho = [];
			this.tmpChiTietKhoDeNghiXuatKho = [...tmp];
			this.changeDetect.detectChanges();
		});
	}
	//#endregion Thao tác thêm hàng, xóa hàng

	getColSpan() {
		return this.displayedColumns.indexOf("SOLUONG")
	}
	getTotalNumber() {
		let total = 0;
		this.tmpChiTietKhoDeNghiXuatKho.forEach(element => {
			total += Number(element.SLThucXuat)
		});
		return total;
	}
	getTotalNumber2() {
		let total = 0;
		this.tmpChiTietKhoDeNghiXuatKho.forEach(element => {
			total += Number(element.SoLuongQuiDoi)
		});
		return total;
	}
	//#region Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng
	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column) return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(
				this.availableColumns,
				this.previousIndex,
				this.findIndexColumn(column)
			);
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(
			true,
			this.availableColumns
		);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];

		if (
			this.KhoDeNghiXuatKhoItem.Tinhtrang == this.Tinhtrang[0].value ||
			this.KhoDeNghiXuatKhoItem.Tinhtrang == ""
		) {
			this.extendColumn.forEach((element) => {
				this.availableColumns.splice(
					this.availableColumns.length,
					0,
					element
				);
			});
			this.selectedColumns = new SelectionModel<any>(
				true,
				this.availableColumns
			);
		}
		this.selectedColumns.selected.forEach((col) => {
			_applySelectedColumns.push(col.name);
		});
		this.displayedColumns = _applySelectedColumns;
	}
	//#endregion Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng

	//#region Lấy danh sách bộ phận
	ListBP(select: boolean = false) {
		const res = this.commonService.listPhongBanAll().subscribe((res) => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {

				this.viewLoading = false;
				this.listListBP = res.data;
				this.listListBP2 = res.data;
				this.filteredListBP.next(this.listListBP.slice());
				this.filteredListBP2.next(this.listListBP2.slice());
				if (
					this.isFromKHSX &&
					this.tmpChiTietKhoDeNghiXuatKho.length > 0
				) {
					this.tmpChiTietKhoDeNghiXuatKho.forEach((item) => {
						this.listListBP.forEach((bp) => {
							item.BPDN = this.idPBMacDinhFromSX;
							item.BPSD = this.idPBMacDinhFromSX;
							if (bp.Id_PB == item.BPDN) item.TenBPDN = bp.TenPB;
							if (bp.Id_PB == item.BPSD) item.TenBPSD = bp.TenPB;
						});
					});
				}
				this.changeDetect.detectChanges();
			}
		});
	}
	filterListBP() {
		if (!this.listListBP) {
			return;
		}
		// get the search keyword
		let search = this.ListBPFilterCtrl;
		if (!search) {
			this.filteredListBP.next(this.listListBP.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredListBP.next(
			this.listListBP.filter(
				(ts) => ts.TenPB.toLowerCase().indexOf(search) > -1
			)
		);
		this.changeDetect.detectChanges();
	}

	filterListBP2() {
		if (!this.listListBP2) {
			return;
		}
		// get the search keyword
		let search = this.ListBP2FilterCtrl;
		if (!search) {
			this.filteredListBP2.next(this.listListBP2.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredListBP2.next(
			this.listListBP2.filter(
				(ts) => ts.TenPB.toLowerCase().indexOf(search) > -1
			)
		);
		this.changeDetect.detectChanges();
	}
	//#endregion Lấy danh sách phòng ban

	//#region Lấy danh sách số phiếu DHB
	ListSPDHB(select: boolean = false) {
		const res = this.KhoDeNghiXuatKhoService.liteSPDHB().subscribe(
			(res) => {
				this.loadingSubject.next(false);
				if (res && res.status === 1) {
					this.viewLoading = false;
					this.listListSPDHB = res.data;
					this.filteredListSPDHB.next(this.listListSPDHB.slice());
					this.changeDetect.detectChanges();
				}
			}
		);
	}
	filterListSPDHB() {
		if (!this.listListSPDHB) {
			return;
		}
		// get the search keyword
		let search = this.ListSPDHBFilterCtrl;
		if (!search) {
			this.filteredListSPDHB.next(this.listListSPDHB.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredListSPDHB.next(
			this.listListSPDHB.filter(
				(ts) => ts.SoPhieu.toLowerCase().indexOf(search) > -1
			)
		);
		this.changeDetect.detectChanges();
	}
	//#endregion Lấy danh sách phòng ban

	//#region Hỗ trợ format dữ liệu form, validate
	changeValueOfForm(controlName: string, event: any) {
		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = this.KhoDeNghiXuatKhoSubForm.controls[
				controlName
			].value.replace(/,/g, "");
			if (!this.KhoDeNghiXuatKhoSubForm.controls[controlName].invalid) {
				this.KhoDeNghiXuatKhoSubForm.controls[controlName].setValue(
					this.f_number(tmpValue)
				);
			}
			if (tmpValue.indexOf(".") == 0 && tmpValue.length == 1) {
				tmpValue = 0;
			}
			this.KhoDeNghiXuatKhoSubForm.controls[controlName].setValue(
				this.f_number(tmpValue)
			);
		} else {
			this.KhoDeNghiXuatKhoSubForm.controls[controlName].setValue(
				"" + event.target.value
			);
		}
	}

	ValidateChangeNumberForm(event: any, isEvent: boolean = true) {
		var count = 0;
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == ",") {
					count += 1;
				}
			}
		} else {
			for (let i = 0; i < event.length; i++) {
				if (event[i] == ",") {
					count += 1;
				}
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = isEvent
			? event.target.value.match(regex)
			: event.match(regex);

		if (found != null) {
			return false;
		}
		if (count >= 2) {
			return false;
		}
		return true;
	}

	validateInvalidSubForm(isAddDetail: boolean = false) {
		this.hasSubFormErrors = false;
		const controls = this.KhoDeNghiXuatKhoSubForm.controls;
		//this.valueSLTon = this.formatComparenumber(this.KhoDeNghiXuatKhoSubForm.controls["SoLuongQuiDoi"].value);
		//this.KhoDeNghiXuatKhoSubForm.controls["SoLuongQuiDoi"].setValidators([Validators.compose([Validators.required,Validators.maxLength(24), Validators.max(this.formatComparenumber(controls['SLTON'].value)),Validators.pattern('^(([1-9][0-9]{0,2},([0-9]{3},)*)[0-9]{3}(\\.[0-9]{1,})?|([1-9]([0-9]+)?)(\\.[0-9]{1,})?|[0](\\.([1-9][0-9]?|[0][1-9])))$')]),this.maxNumberValidator]);
		if (this.KhoDeNghiXuatKhoSubForm.invalid) {
			const invalidElements = this.el.nativeElement.querySelectorAll(
				".ng-invalid"
			);
			if (invalidElements.length > 0) {
				for (let i = 0; i < invalidElements.length; i++) {
					if (
						invalidElements[i].nodeName == "INPUT" ||
						invalidElements[i].nodeName == "MAT-SELECT"
					) {
						const elementControl = this.KhoDeNghiXuatKhoSubForm.get(
							invalidElements[i].attributes.getNamedItem(
								"formcontrolname"
							).value
						);
						var abc = invalidElements[i].attributes.getNamedItem(
							"formcontrolname"
						).value;
						if (elementControl && elementControl.status == "INVALID") {
							setTimeout(() => invalidElements[i].focus(), 100);
							break;
						}
					}
				}
			}
			Object.keys(controls).forEach((controlName) => {
				controls[controlName].markAsTouched();
			});
			this.hasSubFormErrors = false;
			return false;
		}

		if (!isAddDetail) {
			this.forcusAnotherEmptyField(controls);
		}
		return true;
	}

	forcusAnotherEmptyField(control: any) {
		Object.keys(control).forEach((controlName) => {
			if (
				control[controlName].value == null ||
				control[controlName].value == undefined ||
				control[controlName].value == ""
			) {
				// if(controlName == 'GHICHU'){
				// 	setTimeout(() => this.focusGhiChu.first.nativeElement.focus(), 0);
				// }
			}

			this.changeDetect.detectChanges();
		});
	}

	maxNumberValidator(control: AbstractControl) {
		if (control.value != null) {
			let vlControl = +control.value.replace(/,/g, "");
			let vlSlTon = this.f_number(control.parent.controls["SLTON"].value);
			if (vlControl > 0 && vlControl > vlSlTon) {
				return { maxNumberValidator: true };
			}
		}
		return null;
	}

	// formatNumber(item: string){
	// 	if(item == '' || item == null || item == undefined)	return '';
	// 	return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-'+ this.fixedPoint).toFixed(this.fixedPoint)
	// }

	// f_currency(value: string): any {
	// 	if (value == null || value == undefined || value == '' || value == '0') value = '0.00';
	// 	let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
	// 	return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
	// }

	// f_currency_V2(value: string): any {
	// 	if(value == '-1') return '';
	// 	if (value == null || value == undefined || value == '') value = '0';
	// 	let nbr = Number((value + '').replace(/,/g, ""));
	// 	return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	// }

	getFormatDate(v: string = "") {
		if (v != "") {
			return v.includes("T")
				? v.replace(
					/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g,
					"$5/$3/$1"
				)
				: v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return "";
	}

	f_convertDate(p_Val: any) {
		if (p_Val == null || p_Val == undefined || p_Val == "") return "";
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return (
			("0" + a.getDate()).slice(-2) +
			"/" +
			("0" + (a.getMonth() + 1)).slice(-2) +
			"/" +
			a.getFullYear()
		);
	}

	dateToDDMMYYYY(__data: any) {
		let __date = new Date(__data);
		return (
			("0" + __date.getDate()).slice(-2) +
			"/" +
			("0" + (__date.getMonth() + 1)).slice(-2) +
			"/" +
			__date.getFullYear()
		);
	}

	// formatComparenumber(number: string){
	// 	return +number.replace(/,/g, "");
	// }
	//#endregion Hỗ trợ format dữ liệu form , validate

	//#region Tạo số phiếu tự động
	async createBillNumber() {
		var category_path = "DNXK";
		var res = await this.commonService.getBillNumber(category_path)
			.toPromise()
			.then((r) => {
				return r;
			});
		if (res && res.status == 1) {
			return res.data;
		} else {
			this.layoutUtilsService.showErorr(
				"Không thể lấy số phiếu tự động."
			);
		}
	}
	//#endregion Tạo số phiếu tự động

	//#region Chuyển trạng thái phiếu
	checkGuiDuyet(checked: boolean = false) {
		if (checked) {
			this.KhoDeNghiXuatKhoForm.controls["DESCTRANGTHAI"].setValue(
				this.Tinhtrang[1].name
			);
			this.KhoDeNghiXuatKhoForm.controls["TRANGTHAI"].setValue(
				this.Tinhtrang[1].value
			);
		} else {
			this.KhoDeNghiXuatKhoForm.controls["DESCTRANGTHAI"].setValue(
				this.Tinhtrang[0].name
			);
			this.KhoDeNghiXuatKhoForm.controls["TRANGTHAI"].setValue(
				this.Tinhtrang[0].value
			);
		}
	}
	//#endregion Chuyển trạng thái phiếu

	//#region Thoát form
	back(btnBack: boolean = false, isClosePopup = false) {
		if (btnBack && this.checkBackNotify()) {
			const MESSAGE = "Các thông tin vừa chỉnh sửa sẽ bị mất nếu bạn không lưu lại?";
			const dialogRef = this.layoutUtilsService.POPConfirm(MESSAGE);

			dialogRef.afterClosed().subscribe((res) => {
				if (!res) return;
				this.routerBack(isClosePopup);
			});
		} else this.routerBack(isClosePopup);
	}
	//#endregion Thoát form

	//#region Xử lý save và gọi api
	onSubmit(action: number) {
		const details = this.tmpChiTietKhoDeNghiXuatKho;
		const form = this.KhoDeNghiXuatKhoForm.controls;

		// .. Validate form
		if (!this.validateForm(details)) return;

		// .. Kiểm tra danh sách chi tiết
		const copyDetails = [...this.tmpChiTietKhoDeNghiXuatKho];
		const recordTrue = details
			.filter((itElement) => !itElement.isError)
			.map((itElement) => {
				itElement.SoMay = itElement.SoMayArr ? itElement.SoMayArr.join(", ") : "";
				itElement.SXSM = itElement.SXSMArr ? itElement.SXSMArr.join(", ") : "";
				itElement.NSX = itElement.NSXArr ? itElement.NSXArr.join(", ") : "";
				itElement.HSD = itElement.HSDArr ? itElement.HSDArr.join(", ") : "";
				itElement.MaThung = itElement.MaThungArr ? itElement.MaThungArr.join(", ") : "";
				delete itElement.SoMayArr;
				delete itElement.SXSMArr;
				delete itElement.NSXArr;
				delete itElement.HSDArr;
				delete itElement.MaThungArr;
				delete itElement.searchNewPSD;
				delete itElement.listNewBPSD;
				return itElement;
			});

		if (recordTrue.length == 0) {
			const message = "Vui lòng thêm hàng hóa vào danh sách đề nghị.";
			this.layoutUtilsService.showErorr(message);
			this.tmpChiTietKhoDeNghiXuatKho = [...copyDetails];
			this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];
			return;
		}

		// .. Handle SOPHIEU and other form data
		if (!form["SOPHIEU"].value) {
			const message = "Xảy ra lỗi lấy số phiếu, vui lòng tải lại trang để cập nhật.";
			this.layoutUtilsService.showErorr(message);
			this.tmpChiTietKhoDeNghiXuatKho = [...copyDetails];
			this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];
			return;
		}

		const data = new KhoDeNghiXuatKhoPage();
		data.clear();
		data.Sophieu = form["SOPHIEU"].value;
		data.LoaiPhieu = +form["LOAIPHIEU"].value;
		data.Ghichu = form["GHICHU"].value;
		data.Tinhtrang = action == CONFIGURATION.SAVE_TEMP ? DEFAULT.LIST_STATUS[0].value : DEFAULT.LIST_STATUS[1].value;
		data.Lydocode = form["LYDOXUAT"].value == CONFIGURATION.OTHER_REASONS.key ? null : form["LYDOXUAT"].value;
		data.Lydo = this.takeValueSelectedReason();
		data.ChungTuKemTheo = form["CHUNGTUKEMTHEO"].value;
		data.TenSoChungTu = data.ChungTuKemTheo ? form["TENSOCHUNGTU"].value : "";
		data.ChiTiet = recordTrue;

		if (this.toggleReturnTypeAndReasonForReuturnSupplier()) {
			data.SupplierId = form["SUPPLIER_CODE"] ? +form["SUPPLIER_CODE"].value : null;
		} else if (this.toggleReturnTypeAndAnotherReason()) {
			data.Receiver = form['RECEIVER_NAME'] ? form['RECEIVER_NAME'].value : '';
			data.AddressReceiveProduct = form['ADDRESS_RECEIVE_PRODUCT'] ? form['ADDRESS_RECEIVE_PRODUCT'].value : '';
		}

		// .. Handle actions
		if ([CONFIGURATION.SAVE_NEW, CONFIGURATION.SAVE_NEW].includes(action)) {
			const _sophieu: string = data.Sophieu;
			const dialogRef = this.layoutUtilsService.POP02(_sophieu);
			dialogRef.afterClosed().subscribe((res) => {
				if (!res) {
					this.changeDetect.detectChanges();
					return;
				}
				this.navigateSubmit(data, action);
			});
		} else {
			this.navigateSubmit(data, action);
		}
	}

	// .. Điều hường chức năng submit
	navigateSubmit(data, action) {
		if (this.KhoDeNghiXuatKhoItem.IdDn > 0) {
			data.IdDn = this.KhoDeNghiXuatKhoItem.IdDn;
			this.updateKhoDeNghiXuatKho(data, action);
			return;
		}
		this.addKhoDeNghiXuatKho(data, action);
	}

	updateKhoDeNghiXuatKho(item: KhoDeNghiXuatKhoPage, withBack: number = 0) {
		const form = this.KhoDeNghiXuatKhoSubForm.controls
		this.KhoDeNghiXuatKhoService.edit(item).subscribe((res) => {
			if (res && res.status == 1) {
				const message = SUCCESS.UPDATE_SUCCESS.replace(/_sophieu_/g, res.data.Sophieu);
				this.layoutUtilsService.showInfo(message);
				form["NGAYCAN"].setValue(new Date());
				// .. Cập nhật lại khi đã thêm
				this.isChange = true;
				this.saveAddedTTHV = [];
				this.saveAddedTTHV.push(res.data.IdDn);

				switch (withBack) {
					case CONFIGURATION.SAVE_TEMP: {
						this.navSaveTemp(res.data);
						break;
					}
					case CONFIGURATION.SAVE_EDIT: {
						this.checkGuiDuyet(false);
						this.navSaveAdd();
						break;
					}
					case CONFIGURATION.SAVE_NEW: {
						this.checkGuiDuyet(false);
						this.navSaveBack()
						break;
					}
				}
			} else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}

	navSaveTemp(data) {
		this.KhoDeNghiXuatKhoItem = data;
		this.router.navigateByUrl(CONFIGURATION.NAVIGATE_UPDATE + data.IdDn);
		this.changeDetect.detectChanges();
		return;
	}

	navSaveAdd() {
		const form = this.KhoDeNghiXuatKhoSubForm.controls
		let idPhongBan = "";
		this.tokenStorage.getCoCauId().subscribe((a) => { idPhongBan = "" + a; });
		this.KhoDeNghiXuatKhoItem = new KhoDeNghiXuatKhoPage();
		this.KhoDeNghiXuatKhoItem.clear();
		this.createForm();
		setTimeout(() => {
			this.createBillNumber().then((r) => {
				form["SOPHIEU"].setValue(r);
			});
		}, 10);

		this.tmpChiTietKhoDeNghiXuatKho = [];
		this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho,];
		this.createBillNumber().then((r) => {
			form["SOPHIEU"].setValue(r);
		});
		form["NGAYLAP"].setValue(new Date());
		form["TRANGTHAI"].setValue(DEFAULT.LIST_STATUS[0].value);
		form["LOAIPHIEU"].setValue("0");
		form["GHICHU"].setValue("");
		form["LYDOXUAT"].setValue("");
		form["LYDOKHAC"].setValue("");
		this.router.navigateByUrl(CONFIGURATION.NAVIGATE_ADD);
		this.changeDetect.detectChanges();
		return;
	}

	navSaveBack() {
		this.KhoDeNghiXuatKhoForm.reset();
		this.tmpChiTietKhoDeNghiXuatKho = [];
		this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho,];
		this.back();
		return;
	}

	addKhoDeNghiXuatKho(item: KhoDeNghiXuatKhoPage, withBack: number = 0) {
		this.KhoDeNghiXuatKhoService.insert(item).subscribe((res) => {
			if (res && res.status == 1) {
				const message =
					"Phiếu đề nghị xuất kho " +
					res.data.Sophieu +
					" tạo mới thành công.";
				this.layoutUtilsService.showInfo(message);

				let queryParams = new QueryParamsModel(
					{},
					"desc",
					"NGAYLAPPHIEU",
					0,
					10
				);
				this.KhoDeNghiXuatKhoService.lastFilter$.next(queryParams);

				// Cập nhật lại khi đã thêm
				this.isChange = true;
				this.saveAddedTTHV = [];
				this.saveAddedTTHV.push(res.data.IdDn);

				this.KhoDeNghiXuatKhoSubForm.controls["NGAYCAN"].setValue(
					new Date()
				);
				//this.KhoDeNghiXuatKhoSubForm.controls['GHICHU'].setValue('');

				// Lưu nháp
				if (withBack == 0) {
					this.KhoDeNghiXuatKhoItem = res.data;
					this.router.navigateByUrl(
						"/de-nghi-xuat-kho/chinh-sua/" + res.data.IdDn
					);
					this.changeDetect.detectChanges();
					return;
				}

				this.checkGuiDuyet(false);

				// Lưu và thêm mới
				if (withBack == 2) {
					let idPhongBan = "";
					this.tokenStorage.getCoCauId().subscribe((a) => {
						idPhongBan = "" + a;
					});

					this.KhoDeNghiXuatKhoItem = new KhoDeNghiXuatKhoPage();
					this.KhoDeNghiXuatKhoItem.clear();
					this.createForm();
					setTimeout(() => {
						this.createBillNumber().then((r) => {
							this.KhoDeNghiXuatKhoForm.controls[
								"SOPHIEU"
							].setValue(r);
						});
					}, 10);
					this.tmpChiTietKhoDeNghiXuatKho = [];
					this.tmpChiTietKhoDeNghiXuatKho = [
						...this.tmpChiTietKhoDeNghiXuatKho,
					];
					this.KhoDeNghiXuatKhoForm.controls["NGAYLAP"].setValue(
						new Date()
					);
					this.KhoDeNghiXuatKhoForm.controls["TRANGTHAI"].setValue(
						this.Tinhtrang[0].value
					);
					this.KhoDeNghiXuatKhoForm.controls["LOAIPHIEU"].setValue(
						this.typeOptions ? this.typeOptions[0].Id.toString() : "0"
					);
					this.KhoDeNghiXuatKhoForm.controls["GHICHU"].setValue(
						""
					);
					this.KhoDeNghiXuatKhoItem.LoaiPhieu = this.typeOptions[0].Id
					this.router.navigate(["./de-nghi-xuat-kho/them-moi"], {
						skipLocationChange: true,
					});

					this.changeDetect.detectChanges();
					return;
				}
				// Lưu và trờ lại
				if (withBack == 1) {
					this.KhoDeNghiXuatKhoForm.reset();
					this.tmpChiTietKhoDeNghiXuatKho = [];
					this.tmpChiTietKhoDeNghiXuatKho = [
						...this.tmpChiTietKhoDeNghiXuatKho,
					];
					this.back();
				}
			} else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	// Gửi thông báo
	addNotification(IdNof: number, Message: string) {
		this.commonService.sendNotificationsToSetting(
			IdNof,
			Message
		).subscribe((res) => { });
	}

	//#endregion Xử lý save và gọi api

	//#region Hàng hóa
	ListId_HH(keyword: string = "", top: number = 0) {
		this.loadingMerchandise.next(true);
		this.spinnerHH = true;
		this.KhoDeNghiXuatKhoSubForm.controls["MAHH"].disable();
		this.commonService.top_list_of_merchandise_lite(keyword, top).subscribe((res) => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_HH = res.data;
				this.sumRecord = this.listId_HH.length;
				this.filteredId_HH.next(this.listId_HH.slice());
				this.KhoDeNghiXuatKhoSubForm.controls["MAHH"].enable();
			}
			this.spinnerHH = false;
			this.changeDetect.detectChanges();
			this.loadingMerchandise.next(false);
			this.loadingSubject.next(true);
		});
	}

	filterId_HH(searchTmp: string = "") {
		let tmpListHH = [];
		tmpListHH = this.listId_HH;
		if (!tmpListHH) {
			return;
		}
		// get the search keyword
		let search = this.Id_HHFilterCtrl;
		if (searchTmp != "") search = "" + searchTmp;

		if (!search) {
			this.sumRecord = tmpListHH.length;
			this.filteredId_HH.next(tmpListHH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}

		if (searchTmp != "") {
			this.sumRecord = tmpListHH.filter(
				(ts) => ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1
			).length;
			this.filteredId_HH.next(
				tmpListHH.filter(
					(ts) => ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1
				)
			);
		} else {
			this.sumRecord = tmpListHH.filter(
				(ts) => ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1
			).length;
			this.filteredId_HH.next(
				tmpListHH.filter(
					(ts) => ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1
				)
			);
		}

		this.changeDetect.detectChanges();
	}

	afterSelectHH(value: string) {
		const controls = this.KhoDeNghiXuatKhoSubForm.controls;
		const subForm = this.KhoDeNghiXuatKhoSubForm.controls;

		this.listId_HH.forEach((element) => {
			if (element.Id_HH == +value) {
				this.selectId_HH = value;

				// .. Enable field sub form
				subForm["SOLO"].enable();
				subForm["SOMAY"].enable();
				subForm["SOMEXE"].enable();
				subForm["NSX"].enable();
				subForm["HSD"].enable();
				subForm["MATHUNG"].enable();

				// .. Set controls
				controls["MAHH"].setValue(element.MaHH);
				controls["MAHH"].disable();
				controls["TENHH"].setValue(element.TenHH);
				controls["QUYCACH"].setValue(element.QuyCach);
				controls["DVTQuiDoi"].setValue(element.TenDVT);
				controls["SoLuongQuiDoi"].setValue(FunctionPublic.TEXT_MIN_POINT);
				controls["SLTON"].setValue(this.f_number(element.TongSoLuongTon));

				// .. Set data vào dánh sách
				this.listMachineCode = this.isNullEmptyArr(element.CodeMachines) ? [] : element.CodeMachines.split(",");
				this.batchQuantityList = this.isNullEmptyArr(element.SoXeSoMe) ? [] : element.SoXeSoMe.split(",");
				this.manufacturingDateList = this.isNullEmptyArr(element.NgaySanXuat) ? [] : element.NgaySanXuat.split(",");
				this.expirationDateList = this.isNullEmptyArr(element.HanSuDung) ? [] : element.HanSuDung.split(",");
				this.containerCodeList = this.isNullEmptyArr(element.MaThungTP) ? [] : element.MaThungTP.split(",");

				this.validateInvalidSubForm();
				this.clearObjTHCP();
			}
		});
	}

	clearSelectHH(event: any) {
		let controls = this.KhoDeNghiXuatKhoSubForm.controls;
		this.searchWithKeyword();
		this.selectId_HH = "";
		this.listMachineCode = [];

		// Nếu đang thực hiện update dòng thì không xóa data subForm
		if (this.rowUpdate != -1)
			return;

		// ... Set value
		controls["MAHH"].setValue("");
		controls["TENHH"].setValue("");
		controls["QUYCACH"].setValue("");
		controls["DVTQuiDoi"].setValue("");
		controls["SLTON"].setValue(this.f_number());
		controls["SoLuongQuiDoi"].setValue(this.f_number());
		controls["SOMAY"].setValue("");
		controls["SOMEXE"].setValue("");
		controls["NSX"].setValue("");
		controls["HSD"].setValue("");
		controls["MATHUNG"].setValue("");

		// ... Enable & disable
		controls["MAHH"].enable();
		controls["SOLO"].disable();
		controls["SOMAY"].disable();
		controls["SOMEXE"].disable();
		controls["NSX"].disable();
		controls["HSD"].disable();
		controls["MATHUNG"].disable();

		// ... Fill data hàng hóa
		this.sumRecord = this.listId_HH.length;
		this.filteredId_HH.next(this.listId_HH.slice());
		this.changeDetect.detectChanges();
	}
	//#endregion Hàng hóa

	//#region Chuyển tab
	tabChange(event: MatTabChangeEvent) {
		if (event.index == 0) {
			this.resetSubForm();
			// setTimeout(() => {
			// 	this.focusDetail.first.nativeElement.focus();
			// }, 500);
		}
		this.changeDetect.detectChanges();
	}
	//#endregion Chuyển tab

	//#region Reset Form
	resetSubForm() {
		const subForm = this.KhoDeNghiXuatKhoSubForm;
		const subFormControl = subForm.controls;

		// .. Store current values
		const dateCurrent = subFormControl["NGAYCAN"].value;
		const mucDichCurrent = subFormControl["MUCDICHSUDUNG"].value;
		const tmpBPDN = subFormControl["BPDN"].value;
		const tmpBPSD = subFormControl["BPSD"].value;
		const tmpNewBPSD = subFormControl["DIVISION"].value;

		// .. Reset form
		this.KhoDeNghiXuatKhoSubForm.reset();

		// .. Set default values
		this.selectId_HH = "";
		this.selectListSPDHB = "";
		this.listMachineCode = [];
		this.batchQuantityList = [];
		this.manufacturingDateList = [];
		this.expirationDateList = [];
		this.containerCodeList = [];

		// .. Set default values form
		subFormControl["MAHH"].setValue("");
		subFormControl["SLTON"].setValue(FunctionPublic.TEXT_MIN_POINT);
		subFormControl["NGAYCAN"].setValue(dateCurrent);
		subFormControl["SoLuongQuiDoi"].setValue(FunctionPublic.TEXT_MIN_POINT);
		subFormControl["MUCDICHSUDUNG"].setValue(mucDichCurrent);
		subFormControl["BPDN"].setValue(tmpBPDN);
		subFormControl["BPSD"].setValue(tmpBPSD);
		subFormControl["DIVISION"].setValue(tmpNewBPSD);

		// .. Enable/Disable form
		subFormControl["OBJTHCP"].disable();
		subFormControl["MAHH"].enable();
		subFormControl["SOLO"].disable();
		subFormControl["SOMAY"].disable();
		subFormControl["SOMEXE"].disable();
		subFormControl["NSX"].disable();
		subFormControl["HSD"].disable();
		subFormControl["MATHUNG"].disable();

		// .. Update sumRecord and filteredId_HH
		this.sumRecord = this.listId_HH.length;
		this.filteredId_HH.next(this.listId_HH.slice());
	}
	//#endregion Reset Form

	//#region Change DOM
	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges();
		}
	}
	//#endregion Change DOM

	//#region Import
	Importfile() {
		let el: any = this.fileUploadImport.nativeElement;
		var service = this.KhoDeNghiXuatKhoService;

		for (var idx = 0; idx < el.files.length; idx++) {
			var extension = el.files[idx].name.split(".").pop();
			var fileName = el.files[idx].name.substring(
				0,
				el.files[idx].name.indexOf(extension) - 1
			);

			let reader = new FileReader();
			reader.readAsDataURL(el.files[idx]);

			reader.onload = function () {
				let base64Str = reader.result as String;
				var metaIdx = base64Str.indexOf(";base64,");
				base64Str = base64Str.substr(metaIdx + 8);

				var data = {
					fileName: fileName,
					base64: base64Str,
					extension: extension,
				};

				service.lastFileUpload$.next(data);
				service.uploadFileImport(data).subscribe((res) => {
					if (res && res.status == 1) {
						service.data_import.next(res.data);
					} else {
						service.lastFilterDSExcel$.next([]);
						service.lastFilterInfoExcel$.next(undefined);
						return;
					}
				});
			};
		}
	}

	clearErrorData() {
		for (let i = 0; i < this.tmpChiTietKhoDeNghiXuatKho.length; i++) {
			if (this.tmpChiTietKhoDeNghiXuatKho[i].isError) {
				this.tmpChiTietKhoDeNghiXuatKho.splice(i, 1);
				i--;
			}
		}
		this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];
	}

	checkErrorData() {
		for (let i = 0; i < this.tmpChiTietKhoDeNghiXuatKho.length; i++) {
			if (this.tmpChiTietKhoDeNghiXuatKho[i].isError) {
				return true;
			}
		}
		return false;
	}

	clearDataImport() {
		this.KhoDeNghiXuatKhoService.data_import.next([]);
	}

	selectFile(fileUploadImport: any) {
		let el: HTMLElement = this.fileUploadImport
			.nativeElement as HTMLElement;
		el.click();
	}

	FileSelected(evt: any) {
		if (evt.target.files && evt.target.files.length) {
			let file = evt.target.files[0];
			let fileName = file.name;
			var res = fileName.match(/.xlsx$/g);
			if (res) {
				if (!res["includes"](".xlsx")) {
					this.layoutUtilsService.showErorr(
						"File không hợp lệ, chỉ nhận file định dạng xlsx"
					);
					return;
				} else {
					this.ImportHHForm.controls["FileDuLieu"].patchValue(
						fileName
					);
					//this.KhoDeNghiXuatKhoForm.controls['LoaiPhieu'].disable();
					this.processImport = true;
					this.changeDetectView();
					this.Importfile();
				}
			} else {
				this.layoutUtilsService.showErorr(
					"File không hợp lệ, chỉ nhận file định dạng xlsx"
				);
				return;
			}
		} else {
			//Không có file
			this.ImportHHForm.controls["FileDuLieu"].patchValue("");
		}
		evt.target.type = "text";
		evt.target.type = "file";
	}
	//#endregion Import

	//#region Kiểm tra định dạng số lượng
	keyUpInputKhoiLuong(event) {
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		} else {
			FunctionPublic.preventAlphaV2(event);
		}
	}

	changeInputKhoiLuong(event, columnName) {
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		} else {
			if (
				event.keyCode === 46 ||
				event.keyCode === 37 ||
				event.keyCode === 39 ||
				event.keyCode === 8 ||
				event.keyCode === 9
			) {
				return;
			}

			let data = FunctionPublic.slListChanged(event);
			if (data) {
				this.KhoDeNghiXuatKhoSubForm.controls[columnName].setValue(
					data
				);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
				this.changeDetect.detectChanges();
			}
		}
	}
	//#endregion Kiểm tra định dạng số lượng

	//#region Hàm kiểm tra trường hợp lỗi số lượng
	showErrorInputSL() {
		let message = "";
		let controls = this.KhoDeNghiXuatKhoSubForm.controls;
		if (controls == null) return message;
		if (!controls["SoLuongQuiDoi"].value || controls["SoLuongQuiDoi"].value.length == 0 || +this.f_number(controls["SoLuongQuiDoi"].value) == 0)
			return "Số lượng <b>là bắt buộc</b>";
		if (
			controls["SoLuongQuiDoi"].hasError("maxlength") ||
			(controls["SoLuongQuiDoi"].value.length > 22 &&
				(controls["SoLuongQuiDoi"].value.indexOf(".") == 0 ||
					controls["SoLuongQuiDoi"].value.indexOf(".") > 21))
		)
			return "Tối đa 18 chữ số với 2 chữ số thập phân";
		if (
			+this.f_number(controls["SLTON"].value) === 0 &&
			controls["MAHH"].value
		)
			return "Hết hàng";
		//if(this.formatComparenumber(controls['SLTON'].value) > 0) message+= 'Vượt số lượng tồn!';
		return message;
	}
	//#endregion Hàm kiểm tra trường hợp lỗi số lượng

	selectedSPDHB(event) {
		let tmp = event.value ? event.value : event;
		if (tmp) {
			var index = this.listListSPDHB.findIndex((x) => x.Id == +tmp);
			if (index > -1) {
				this.KhoDeNghiXuatKhoSubForm.controls["MAKH"].setValue(
					this.listListSPDHB[index].MaKH
				);
				this.KhoDeNghiXuatKhoSubForm.controls["TENKH"].setValue(
					this.listListSPDHB[index].TenKH
				);
				let listHH = [];
				if (this.listListSPDHB[index].ListHH.length > 0) {
					listHH = this.listId_HH.filter(
						(x) =>
							this.listListSPDHB[index].ListHH.indexOf(x.Id_HH) >
							-1
					);
					this.sumRecord = listHH.length;
					this.filteredId_HH.next(listHH.slice());
				} else {
					this.sumRecord = 0;
					this.filteredId_HH.next([]);
				}
				let controls = this.KhoDeNghiXuatKhoSubForm.controls;
				this.selectId_HH = "";
				this.listMachineCode = [];
				controls["MAHH"].setValue("");
				controls["TENHH"].setValue("");
				controls["QUYCACH"].setValue("");
				controls["DVTQuiDoi"].setValue("");
				controls["SLTON"].setValue(this.f_number());
				//controls["SoLuongQuiDoi"].setValidators([Validators.compose([Validators.required,Validators.maxLength(24),Validators.max(this.formatComparenumber(controls['SLTON'].value)),Validators.pattern('^(([1-9][0-9]{0,2},([0-9]{3},)*)[0-9]{3}(\\.[0-9]{1,})?|([1-9]([0-9]+)?)(\\.[0-9]{1,})?|[0](\\.([1-9][0-9]?|[0][1-9])))$')]),this.maxNumberValidator]);
				controls["MAHH"].enable();
			}
			this.changeDetect.detectChanges();
		}
	}

	closeDropdownEvent(dropdownName: string) {
		if (dropdownName == "SoPhieuDHB") {
			setTimeout(() => this.focusSoPhieuDHB.first.close(), 0);
			this.changeDetect.detectChanges();
		}
		this.changeDetect.detectChanges();
	}

	clearSelectSPDHB(event: any) {
		let controls = this.KhoDeNghiXuatKhoSubForm.controls;
		this.selectListSPDHB = "";
		// controls["MAKH"].setValue('');
		// controls["TENKH"].setValue('');
		// controls["SOPHIEUDHB"].setValue('');
		this.sumRecord = this.listId_HH.length;
		this.filteredId_HH.next(this.listId_HH.slice());
		this.clearSelectHH(event);
		//event.stopPropagation();
	}

	timKiemNangCao() {
		this.openTimKiemNangCao = true;

		const dialogRef = this.dialog.open(TimKiemNangCaoListComponent, {
			data: {
				kw: this.focusDetail.first.nativeElement.value,
			},
			maxHeight: "90vh",
			width: "90vw",
		});
		dialogRef.afterClosed().subscribe((res) => {
			this.openTimKiemNangCao = false;
			if (res == undefined || res == null) {
				return;
			} else {
				if (!res.isChange) {
					return;
				}
				if (res.dataAdd.length != 0) {
					this.afterSelectHH(res.dataAdd.toString());
				}
			}
		});
	}

	xuLyDauVaoCTSLT(
		form: boolean = true,
		item: KhoDeNghiXuatKhoPageChiTiet = null
	) {
		if (form) {
			if (!this.selectId_HH) {
				this.layoutUtilsService.showErorr(
					"Vui lòng chọn hàng hoá trước khi xem chi tiết số lượng tồn"
				);
				return;
			}
			var Id_HH = Number(this.selectId_HH);
			var index = this.listId_HH.findIndex((x) => x.Id_HH == Id_HH);
			if (index > -1) {
				this.chiTietSoLuongTon(
					Id_HH,
					this.listId_HH[index].MaHH +
					" - " +
					this.listId_HH[index].TenHH
				);
			}
		} else {
			if (item != null) {
				this.chiTietSoLuongTon(
					item.IdHh,
					item.MaHH + " - " + item.TenHH
				);
			}
		}
	}

	chiTietSoLuongTon(IdHH: number, Ma_Ten_HH: string) {
		this.openTimKiemNangCao = true;
		//if (!this.dialogRef) return;

		const dialogRef = this.dialog.open(ChiTietSoLuongTonPageComponent, {
			data: {
				IdHH: IdHH,
				Ma_Ten_HH: Ma_Ten_HH,
			},
			maxHeight: "90vh",
			width: "98vw",
		});
		dialogRef.afterClosed().subscribe((res) => {
			this.openTimKiemNangCao = true;
			setTimeout(() => {
				this.openTimKiemNangCao = false;
			}, 500);
		});
	}

	changeTypeOfVote(event: any) {
		var value = event.value ? event.value : event;
		var flag = false;
		var isChange = false;
		var openKHGHTmpOld = this.openKHGH;
		var openKHGHTmpNew = this.openKHGH;
		const form = this.KhoDeNghiXuatKhoForm.controls;
		const subForm = this.KhoDeNghiXuatKhoSubForm.controls;
		const WARNING_MESSAGE = "Việc thay đổi sẽ mất dữ liệu hiện có. Bạn có muốn thay đổi?";

		// .. Kiểm tra list loại phiếu
		if (this.typeOptions && this.typeOptions.length > 0) {
			this.typeOptions.forEach((x) => {
				if (x.Id.toString() == value) {
					flag = true;
					openKHGHTmpNew = x.OpenKHGH;
				}
			});
		}
		// .. Nếu không thay đổi thì ...
		if (!flag) { openKHGHTmpNew = false; }
		// .. Xử lý nếu loại phiếu bị thay đổi
		if (openKHGHTmpNew != openKHGHTmpOld && this.tmpChiTietKhoDeNghiXuatKho.length > 0) {
			isChange = true;
			const dialogRef = this.layoutUtilsService.POPConfirm(WARNING_MESSAGE);
			dialogRef.afterClosed().subscribe((res) => {
				if (!res) {
					form["LOAIPHIEU"].setValue(this.flagChangeLoaiPhieu.toString());
					this.flagChangeLoaiPhieu = form["LOAIPHIEU"].value.toString();
					return;
				}
				form["LOAIPHIEU"].setValue(event.value.toString());
				this.flagChangeLoaiPhieu = form["LOAIPHIEU"].value.toString();
				this.openKHGH = openKHGHTmpNew;
				if (this.rowUpdate <= -1) this.clearSelectHH(event);
				this.sumRecord = this.listId_HH.length;
				this.filteredId_HH.next(this.listId_HH.slice());
				if (openKHGHTmpNew != openKHGHTmpOld && this.rowUpdate <= -1) {
					this.tmpChiTietKhoDeNghiXuatKho = [];
					this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho,];
				}
				this.flagChangeLoaiPhieu = form["LOAIPHIEU"].value.toString();
			});
		}
		// .. Nếu không thay đổi
		if (isChange == false) {
			this.openKHGH = openKHGHTmpNew;
			if (this.rowUpdate <= -1) this.clearSelectHH(event);
			this.sumRecord = this.listId_HH.length;
			this.filteredId_HH.next(this.listId_HH.slice());
			if (openKHGHTmpNew != openKHGHTmpOld && this.rowUpdate <= -1) {
				this.tmpChiTietKhoDeNghiXuatKho = [];
				this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho,];
			}
			this.flagChangeLoaiPhieu = form["LOAIPHIEU"].value.toString();
		}
		// .. Nếu loại phiếu 'Xuất sử dụng' bắt buộc chọn phòng ban sử dụng
		this.updateRequiredFieldsForDepartmentUse();
		// .. Nếu loại phiếu 'Xuất sử dụng' và Lý do xuất 'Xuất cho hoạt động sản xuất' bắt buộc chọn đối tượn11111g THCP
		this.updateRequiredFieldsForObjTHCP();
		// .. Load lý do xuất kho theo loại phiếu
		this.loadReasonExportDefaultFromExportType();
	}

	holdValueLoaiPhieuBeforeChange() {
		this.KhoDeNghiXuatKhoForm.controls["LOAIPHIEU"].setValue(
			this.flagChangeLoaiPhieu.toString()
		);
		this.changeDetectView();
	}

	checkChangeLoaiPhieu(value: any) {
		const details = this.tmpChiTietKhoDeNghiXuatKho;
		const form = this.KhoDeNghiXuatKhoForm.controls;
		const lenDetails = details.length;
		const index = this.typeOptions.findIndex(x => this.strEquals(this.fStr(x.Id), this.fStr(value)));
		const status = this.typeOptions[index].OpenDHB == this.openDHB;

		if (lenDetails == 0) {
			this.openDHB = this.typeOptions[index].OpenDHB;
			form["LOAIPHIEU"].setValue(this.fStr(value));
			this.flagChangeLoaiPhieu = form["LOAIPHIEU"].value.toString();
		}
		else {
			if (index > -1) {
				if (!status) {
					const dialogRef = this.layoutUtilsService.POPConfirm();
					dialogRef.afterClosed().subscribe((res) => {
						if (!res) {
							form["LOAIPHIEU"].setValue(this.flagChangeLoaiPhieu.toString());
							return;
						}
						form["LOAIPHIEU"].setValue(this.fStr(value));
						this.openDHB = this.typeOptions[index].OpenXHDXL;
						this.flagChangeLoaiPhieu = form["LOAIPHIEU"].value.toString();
						this.acceptChangeLoaiPhieu();
					});
				} else {
					form["LOAIPHIEU"].setValue(this.fStr(value));
					this.openDHB = this.typeOptions[index].OpenXHDXL;
					this.flagChangeLoaiPhieu = form["LOAIPHIEU"].value.toString();
				}
			}
		}
		this.clearSelectSPDHB(event);
		this.clearSelectHH(event);
		this.sumRecord = this.listId_HH.length;
		this.filteredId_HH.next(this.listId_HH.slice());
	}

	acceptChangeLoaiPhieu() {
		for (var i = this.tmpChiTietKhoDeNghiXuatKho.length - 1; i >= 0; i--) {
			this.tmpChiTietKhoDeNghiXuatKho.splice(i, 1);
		}
		this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];
		this.changeDetectView();
	}

	ImportFileMau() {
		// let linkdownload = this.commonService.downloadTemplate();
		// window.open(linkdownload);
		this.KhoDeNghiXuatKhoService.downloadTemplate(
			+this.KhoDeNghiXuatKhoForm.controls["LOAIPHIEU"].value
		).subscribe((blob) => {
			var downloadLink = document.createElement("a");
			var url = URL.createObjectURL(blob);
			downloadLink.href = url;
			downloadLink.download = "IMPORT_DENGHIXUATKHO_MAU";
			document.body.appendChild(downloadLink);
			downloadLink.click();
			document.body.removeChild(downloadLink);
		});
	}

	keyUpInputNumberVND(event) {
		FunctionPublic.cvKeyUp(event);
	}

	changeInputNumberVND(event, columnName, min: number = 0, formGroup) {
		let controls = formGroup.controls;
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		} else {
			if (
				event.keyCode === 46 ||
				event.keyCode === 37 ||
				event.keyCode === 39 ||
				event.keyCode === 8 ||
				event.keyCode === 9
			) {
				return;
			}

			let data = FunctionPublic.slListChangedV2(event);
			if (data) {
				if (
					this.f_number(data) <= min &&
					event.data &&
					event.data == "0"
				)
					data = this.f_number(min);
				controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;

				if (data.length == 4) {
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}
			} else {
				controls[columnName].setValue(this.f_number(min));
				event.target.selectionStart = 0;
				event.target.selectionEnd = 0;
			}
		}
	}

	// f_currency_VND(value: string): any {
	// 	if (value == null || value == undefined) return '0,00';
	// 	return new Intl.NumberFormat('de-DE',{ style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	// }

	changeInputOfFormVND(
		controlName: string,
		event: any,
		min: number = 0,
		formGroup
	) {
		let controls = formGroup.controls;
		if (controls[controlName].value == "") {
			controls[controlName].setValue(this.f_number(0));
		}

		let tmpValue = controls[controlName].value
			.replace(/\./g, "")
			.replace(/,/g, ".");
		if (isNaN(tmpValue)) tmpValue = 0.0;
		if (Number(tmpValue) < min) tmpValue = min;
		if (!controls[controlName].invalid) {
			controls[controlName].setValue(this.f_number(tmpValue));
		}
		if (tmpValue.toString().indexOf(",") == 0 && tmpValue.length == 1) {
			tmpValue = min;
		}
		controls[controlName].setValue(this.f_number(tmpValue));
	}

	// formatComparenumber(number: string){
	// 	return +number.replace(/\./g, "").replace(/,/g, ".");;
	// }

	getNameKH(tmp) {
		return (
			tmp.SoPhieu +
			(tmp.IdKH > 0 ? " - " + tmp.MaKH + " - " + tmp.TenKH : "")
		);
	}

	showNameToId() {
		let name = "";
		// ;
		// if(this.listListSPDHB.length > 0){
		// 	var item = this.listListSPDHB.filter(x => x.Id == +this.KhoDeNghiXuatKhoSubForm.controls['SOPHIEUDHB'].value);
		// 	if(item.length > 0) name = item[0].SoPhieu;
		// }
		return name ? name : "";
	}

	lichSuXuatKho(item: KhoDeNghiXuatKhoPageChiTiet) {
		this.openTimKiemNangCao = true;
		const dialogRef = this.dialog.open(LichSuXuatKhoComponent, {
			data: {
				IdHH: item.IdHh,
				Ma_Ten_HH: item.MaHH + " - " + item.TenHH,
			},
			maxHeight: "90vh",
			width: "75vw",
		});
		dialogRef.afterClosed().subscribe((res) => {
			this.openTimKiemNangCao = true;
			setTimeout(() => {
				this.openTimKiemNangCao = false;
			}, 500);
		});
	}

	checkBackNotify() {
		let flag = false;
		let value = this.KhoDeNghiXuatKhoItem;
		let controls = this.KhoDeNghiXuatKhoForm.controls;

		if (
			(controls["LOAIPHIEU"].value &&
				+controls["LOAIPHIEU"].value != +value.LoaiPhieu) ||
			this.tmpChiTietKhoDeNghiXuatKho.length !=
			this.KhoDeNghiXuatKhoItem.ChiTiet.length
		) {
			flag = true;
		}

		if (
			this.tmpChiTietKhoDeNghiXuatKho.length ==
			this.KhoDeNghiXuatKhoItem.ChiTiet.length &&
			this.KhoDeNghiXuatKhoItem.ChiTiet.length > 0
		) {
			this.tmpChiTietKhoDeNghiXuatKho.forEach((x) => {
				if (
					this.KhoDeNghiXuatKhoItem.ChiTiet.findIndex(
						(a) =>
							a.IdCtdn == x.IdCtdn &&
							a.IdHh == x.IdHh &&
							a.Soluong == x.Soluong &&
							a.BPSD == x.BPSD &&
							a.BPDN == x.BPDN &&
							a.MucDichSuDung == x.MucDichSuDung &&
							a.SoLo == x.SoLo &&
							a.SoMay == x.SoMay &&
							moment(a.NgayCan).format("DD/MM/YYYY") ==
							moment(x.NgayCan).format("DD/MM/YYYY")
					) == -1
				) {
					flag = true;
				}
			});
		}
		return flag;
	}

	showOverLoad() {
		const subForm = this.KhoDeNghiXuatKhoSubForm.controls;
		const enteredQuantity = subForm["SoLuongQuiDoi"].value ? this.f_number(subForm["SoLuongQuiDoi"].value) : 0;
		const maximumQuantity = subForm["SLTON"].value ? this.f_number(subForm["SLTON"].value) : 0;

		return Number(enteredQuantity) > Number(maximumQuantity);
	}

	changeInputOfFormVNDInList(
		columnName: string,
		event: any,
		min: number = 0,
		item: KhoDeNghiXuatKhoPageChiTiet
	) {
		if (event.target.value == "") {
			event.target.value = this.f_number(min);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}

		if (event.target.value.toString() == item[columnName].toString()) {
			event.target.value = this.f_number(item[columnName]);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}

		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = event.target.value
				.replace(/\./g, "")
				.replace(/,/g, ".");

			if (isNaN(tmpValue)) tmpValue = min;

			if (Number(tmpValue) < min) tmpValue = min;

			if (!item[columnName]) {
				item[columnName] = tmpValue;
			}

			item[columnName] = tmpValue;

			event.target.value = this.f_number(tmpValue);
		} else {
			item[columnName] = min;
		}

		this.changeDetect.detectChanges();
	}

	strTrimCustomer(str: string) {
		return str.trim().length;
	}

	listDonHangBanCT() {
		this.openTimKiemNangCao = true;
		let list = [];
		this.tmpChiTietKhoDeNghiXuatKho.forEach((x) => {
			if (
				list.findIndex(
					(a) =>
						a.IdHh == x.IdHh &&
						!a.DatHangId &&
						a.DatHangId > 0 &&
						a.DatHangId == x.DatHangId &&
						a.DatHangCtId == x.DatHangCtId
				) == -1
			) {
				list.push(x.DatHangCtId);
			}
		});

		list = [...new Set(list)];

		const dialogRef = this.dialog.open(ListDonHangBanCtComponent, {
			data: {
				danhSachId: list,
			},
			maxHeight: "90vh",
			width: "90vw",
		});
		dialogRef.afterClosed().subscribe((res) => {
			this.openTimKiemNangCao = true;

			setTimeout(() => {
				this.openTimKiemNangCao = false;
			}, 500);

			if (res == undefined || res == null) {
				return;
			} else {
				if (res.list.length != 0 && res.action) {
					this.tmpChiTietKhoDeNghiXuatKho = this.tmpChiTietKhoDeNghiXuatKho.concat(
						res.list
					);
					this.tmpChiTietKhoDeNghiXuatKho = [
						...this.tmpChiTietKhoDeNghiXuatKho,
					];
					this.changeDetect.detectChanges();
				}
			}
		});
	}

	getIdPBMacDinhFromSanXuat() {
		this.KhoDeNghiXuatKhoService.getConfigDefaultPBFromKHSanXuat().subscribe(
			(res) => {
				this.loadingSubject.next(false);
				if (res && res.status === 1) {
					this.idPBMacDinhFromSX = res.data;
					if (
						this.isFromKHSX &&
						this.tmpChiTietKhoDeNghiXuatKho.length > 0
					) {
						this.tmpChiTietKhoDeNghiXuatKho.forEach((item) => {
							item.BPDN = this.idPBMacDinhFromSX;
							item.BPSD = this.idPBMacDinhFromSX;
							this.listListBP.forEach((bp) => {
								if (bp.Id_PB == item.BPDN)
									item.TenBPDN = bp.TenPB;
								if (bp.Id_PB == item.BPSD)
									item.TenBPSD = bp.TenPB;
							});
						});
					}
					this.changeDetectView();
				}
			}
		);
	}
	getPlaceHolder() {
		return this.spinnerHH ? "Đang tải..." : "[Chọn hàng hóa]";
	}

	splitStr(str: string) {
		if (!str || str.length == 0) return [];
		return str.split(",");
	}

	convertArrToStr(arr: string[]) {
		if (!arr && arr.length == 0) return "";
		return arr.join(",");
	}

	getListMachineCode(idhh: number) {
		let item = this.listId_HH.find(x => x.Id_HH == idhh);
		if (!item || item.length == 0) return [];
		return this.isNullEmptyArr(item.CodeMachines) ? [] : item.CodeMachines.split(",");
	}
	searchWithKeyword() {
		//this.loadingMerchandise.next(true);
		this.keywordChanged.next(this.Id_HHFilterCtrl);
		this.changeDetectView();
	}
	triggerMerchandise() {
		if (!this.listId_HH || this.listId_HH.length == 0) return "";
		var obj = this.listId_HH.find(x => x.Id_HH == Number(this.selectId_HH));
		return (!this.selectId_HH || !obj) ? "" : obj.MaHH;
	}

	ListDVT() {
		this.commonService.getDSDonViTinh().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listDVT = res.data;
				this.filteredListDVT.next(this.listDVT.slice());
				this.changeDetectView()
			};
		});
	}

	filterDVT() {
		if (!this.listDVT) {
			return;
		}
		let search = this.ListDVTFilterCtrl;

		if (this.KhoDeNghiXuatKhoSubForm.controls["MAHH"].value != null &&
			this.KhoDeNghiXuatKhoSubForm.controls["MAHH"].value != '') {

			let item = this.listId_HH.find(x => x.Id_HH == +this.selectId_HH);
			if (item != null) {
				var listDVTHH = []
				listDVTHH.push(item.DVT);
				if (item.Dvt2 != null && item.Dvt2 > 0)
					listDVTHH.push(item.Dvt2);
				if (item.Dvt3 != null && item.Dvt3 > 0)
					listDVTHH.push(item.Dvt3);

				if (!search) {
					this.filteredListDVT.next(
						this.listDVT.filter(ts => listDVTHH.indexOf(ts.Id_DVT) > -1)
					);
					return;
				} else {
					search = search.toLowerCase();
				}
				this.filteredListDVT.next(
					this.listDVT.filter(ts =>
						listDVTHH.indexOf(ts.Id_DVT) > -1 &&
						ts.TenDVT.toLowerCase().indexOf(search) > -1)
				);
			}
			else {
				if (!search) {
					this.filteredListDVT.next(this.listDVT.slice());
					return;
				} else {
					search = search.toLowerCase();
				}
				this.filteredListDVT.next(
					this.listDVT.filter(ts =>
						ts.TenDVT.toLowerCase().indexOf(search) > -1)
				);
			}
		}
		else {
			if (!search) {
				this.filteredListDVT.next(this.listDVT.slice());
				return;
			} else {
				search = search.toLowerCase();
			}
			this.filteredListDVT.next(
				this.listDVT.filter(ts =>
					ts.TenDVT.toLowerCase().indexOf(search) > -1)
			);
		}

		this.changeDetectView();
	}
	changeDVT(flag: number) {
		this.listId_HH.forEach(element => {
			if (element.Id_HH == +this.selectId_HH) {
				var listDVTHH = []
				listDVTHH.push(element.DVT);
				if (element.Dvt2 != null && element.Dvt2 > 0)
					listDVTHH.push(element.Dvt2);
				if (element.Dvt3 != null && element.Dvt3 > 0)
					listDVTHH.push(element.Dvt3);

				let currentDVT = listDVTHH.findIndex(x => x == +this.KhoDeNghiXuatKhoSubForm.controls["DVTQuiDoi"].value)
				if (currentDVT == 1) {
					var numQuiDoi = Number(this.f_number(this.KhoDeNghiXuatKhoSubForm.controls["SoLuongQuiDoi"].value))
						* Number(element.QuiDoiDVT2)
					if (numQuiDoi > 0) {
						this.soLuong = numQuiDoi;
					}
					if (flag == 1) {
						this.textQuiDoiDVT = this.f_number(Number(this.f_number(this.KhoDeNghiXuatKhoSubForm.controls["SLTON"].value)) / Number(element.QuiDoiDVT2)) + ' ' + element.TenDVT2;
						this.soLuongDaQuiDoi = this.f_number(Number(this.f_number(this.KhoDeNghiXuatKhoSubForm.controls["SLTON"].value)) / Number(element.QuiDoiDVT2))
					}
				}
				else if (currentDVT == 2) {
					var numQuiDoi = Number(this.f_number(this.KhoDeNghiXuatKhoSubForm.controls["SoLuongQuiDoi"].value))
						* Number(element.QuiDoiDVT3)
					if (numQuiDoi > 0) {
						this.soLuong = numQuiDoi;
					}
					if (flag == 1) {
						this.textQuiDoiDVT = this.f_number(Number(this.f_number(this.KhoDeNghiXuatKhoSubForm.controls["SLTON"].value)) / Number(element.QuiDoiDVT3)) + ' ' + element.TenDVT3;
						this.soLuongDaQuiDoi = this.f_number(Number(this.f_number(this.KhoDeNghiXuatKhoSubForm.controls["SLTON"].value)) / Number(element.QuiDoiDVT3));
					}
				}
				else if (currentDVT == 0) {
					if (flag == 1) {
						this.textQuiDoiDVT = this.f_number(Number(this.f_number(this.KhoDeNghiXuatKhoSubForm.controls["SLTON"].value))) + ' ' + element.TenDVT;
						this.soLuongDaQuiDoi = this.f_number(Number(this.f_number(this.KhoDeNghiXuatKhoSubForm.controls["SLTON"].value)));
					}
					this.soLuong = Number(this.f_number(this.KhoDeNghiXuatKhoSubForm.controls["SoLuongQuiDoi"].value));
				}
			}
		});
		this.changeDetectView();
	}
	changeDVTDetail(item) {
		this.listId_HH.forEach(element => {
			if (element.Id_HH == item.IdHh) {
				var listDVTHH = []
				listDVTHH.push(element.DVT);
				if (element.Dvt2 != null && element.Dvt2 > 0)
					listDVTHH.push(element.Dvt2);
				if (element.Dvt3 != null && element.Dvt3 > 0)
					listDVTHH.push(element.Dvt3);

				let currentDVT = listDVTHH.findIndex(x => x == item.DvtQuiDoi)
				if (currentDVT == 1) {
					var numQuiDoi = Number(this.f_number(Number(item.SoLuongQuiDoi) + ',00'))
						* Number(element.QuiDoiDVT2)
					if (numQuiDoi > 0) {
						item.TextQuiDoiDVT = this.f_number(numQuiDoi) + ' ' + element.TenDVT;
						item.Soluong = numQuiDoi;
					}
				}
				else if (currentDVT == 2) {
					var numQuiDoi = Number(this.f_number(Number(item.SoLuongQuiDoi) + ',00'))
						* Number(element.QuiDoiDVT3)
					if (numQuiDoi > 0) {
						item.TextQuiDoiDVT = this.f_number(numQuiDoi) + ' ' + element.TenDVT;
						item.Soluong = numQuiDoi;
					}
				}
				else if (currentDVT == 0) {
					item.TextQuiDoiDVT = this.f_number(item.SoLuongQuiDoi) + ' ' + element.TenDVT;
					item.Soluong = Number(this.f_number(Number(item.SoLuongQuiDoi) + ',00'));
				}
			}
		});
	}
	/*----------------------------Danh sach khach hang --------------------------------*/
	async loadListKhachHang() {
		var res = await this.commonService.layDanhSachKhachHang().toPromise();
		if (res.data != null && res.status === 1) {
			this.listId_KH = res.data;
			this.sumRecord_KH = this.listId_KH.length;
			this.filteredId_KH.next(this.listId_KH.slice());
			if (this.tmpChiTietKhoDeNghiXuatKho.length > 0) {
				this.arrayKHForEachHH = [];
				this.tmpChiTietKhoDeNghiXuatKho.forEach(_x => {
					var _customers = new ReplaySubject<any[]>(1);
					this.arrayKHForEachHH.push(_customers.next(this.listId_KH.slice()));
				});
			}
		}
		else {
			this.filteredId_KH.next([]);
		}
	}

	filterId_KH(searchTmp: string = '') {
		if (!this.listId_KH) {
			return;
		}
		if (searchTmp === '') {
			this.sumRecord_KH = this.listId_KH.length;
			this.filteredId_KH.next(this.listId_KH.slice());
			return;
		}
		else {
			searchTmp = searchTmp.toLowerCase();
			this.sumRecord_KH = this.listId_KH.filter(ts => ts.Makh.toLowerCase().includes(searchTmp) || ts.Tenkh.toLowerCase().includes(searchTmp)).length;
			this.filteredId_KH.next(this.listId_KH.filter(ts => ts.Makh.toLowerCase().includes(searchTmp) || ts.Tenkh.toLowerCase().includes(searchTmp)));
		}
	}
	afterSelectKH(value: string) {
		const controls = this.KhoDeNghiXuatKhoForm.controls;
		this.listId_KH.forEach(element => {
			if (element.IdKh === +value) {
				this.selectedId_KH = Number(value);
				controls["MaKhachHang"].setValue(element.Makh);
				controls["TenKhachHang"].setValue(element.Tenkh);
				controls["MaKhachHang"].disable();
				//controls["GHICHU"].setValue("Xuất kho cho "+ element.Tenkh)
				this.bindValueDienGiai()
			}
		});

	}
	clearSelectKH(event: any) {
		const controls = this.KhoDeNghiXuatKhoForm.controls;
		this.selectedId_KH = 0;
		controls["MaKhachHang"].enable();
		controls["MaKhachHang"].setValue('');
		controls["TenKhachHang"].setValue('');
		// if(this.KhoDeNghiXuatKhoSubForm.controls['NewBPSD'].value != ""){
		// 	var item = this.listBP.find(x=>x.Id_PB == this.KhoDeNghiXuatKhoSubForm.controls['NewBPSD'].value);
		// 	if(item != undefined){
		// 		controls["GHICHU"].setValue("Xuất kho cho "+ item.TenPB)
		// 	}
		// }
		// else{
		// 	controls["GHICHU"].setValue('');	
		// }
		//event.preventDefault();
		event.stopPropagation();
	}
	filterKHItem(index) {
		if (!this.listId_KH) {
			return;
		}
		let search = this.KHFilterCtrl;
		if (!search) {
			this.arrayKHForEachHH[index].next(this.listId_KH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		if (index > -1) {
			this.arrayKHForEachHH[index].next(this.listId_KH.filter(ts => (ts.Makh + ' ' + ts.Tenkh).toLowerCase().indexOf(search) > -1));
		}

		this.changeDetectView();
	}
	afterSelectItemKh(index) {
		let item = this.tmpChiTietKhoDeNghiXuatKho[index];
		if (item) {
			let itemKH = this.listId_KH.find(x => x.IdKh == item.IdKh)
			item.MaKH = itemKH.Makh;
			item.TenKH = itemKH.Tenkh;
			this.bindValueDienGiai();
		}

	}
	/*-----------------------------------------------------------------------------*/
	mergeItem(item) {
		// this.tmpChiTietKhoDeNghiXuatKho.forEach((e) => {
		// 	//----------------- Đã tồn tại -----------------------
		// 	if (e.IdHh == item.IdHh && e.DvtQuiDoi == item.DvtQuiDoi) {
		// 		if (!this.openDHB) {
		// 			if (
		// 				e.BPSD == item.BPSD &&
		// 				e.BPDN == item.BPDN &&
		// 				e.SoMay == item.SoMay &&
		// 				e.SoLo == item.SoLo &&
		// 				item.NgayCan == e.NgayCan
		// 			) {
		// 				e.SoLuongQuiDoi += item.SoLuongQuiDoi;
		// 				e.Soluong += item.Soluong;
		// 				e.TextQuiDoiDVT = e.Soluong + ',00 ' +(item.ListHH ? item.ListHH[0].TenDVT : '');
		// 				e.MucDichSuDung += ", " + item.MucDichSuDung;
		// 				if (item.GhiChu) e.GhiChu += ", " + item.GhiChu;
		// 				flag = false;
		// 			}
		// 		} 
		// 		if (this.openDHB) {
		// 			if (item.DatHangId) {
		// 				if (
		// 					e.DatHangId == item.DatHangId &&
		// 					e.BPDN == item.BPDN &&
		// 					e.BPSD == item.BPSD &&
		// 					e.SoMay == item.SoMay &&
		// 					e.SoLo == item.SoLo &&
		// 					item.NgayCan == e.NgayCan
		// 				) {
		// 					e.SoLuongQuiDoi += item.SoLuongQuiDoi;
		// 					e.Soluong += item.Soluong;
		// 					e.TextQuiDoiDVT = e.Soluong + ',00 ' + (item.ListHH ? item.ListHH[0].TenDVT : '');
		// 					e.MucDichSuDung += ", " + item.MucDichSuDung;
		// 					if (item.GhiChu) e.GhiChu += ", " + item.GhiChu;
		// 					flag = false;
		// 				}
		// 			} else {
		// 				if (
		// 					!e.DatHangId &&
		// 					e.BPDN == item.BPDN &&
		// 					e.BPSD == item.BPSD &&
		// 					e.SoMay == item.SoMay &&
		// 					e.SoLo == item.SoLo &&
		// 					item.NgayCan == e.NgayCan
		// 				) {
		// 					e.SoLuongQuiDoi += item.SoLuongQuiDoi;
		// 					e.Soluong += item.Soluong;
		// 					e.TextQuiDoiDVT = e.Soluong + ',00 ' + (item.ListHH ? item.ListHH[0].TenDVT : '');
		// 					e.MucDichSuDung += ", " + item.MucDichSuDung;
		// 					if (item.GhiChu) e.GhiChu += ", " + item.GhiChu;
		// 					flag = false;
		// 				}
		// 			}
		// 		}
		// 	}
		// });

		// if (flag) this.tmpChiTietKhoDeNghiXuatKho.push(item);
		// let tmp = this.tmpChiTietKhoDeNghiXuatKho;

		// this.resetSubForm();
		// //setTimeout(() => this.focusDetail.first.nativeElement.focus(), 500);
		// this.textQuiDoiDVT = '';
		// this.soLuong = 0;
		// this.tmpChiTietKhoDeNghiXuatKho = [...tmp];
		// this.changeDetect.detectChanges();
	}

	// ---< Danh sách bộ phận sử dụng >----------------------------------------  
	listNewBPSD() {
		this.commonService.listBoPhanAll().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listBP = res.data;
				this.filteredBP.next(this.listBP.slice());
				if (this.tmpChiTietKhoDeNghiXuatKho && this.tmpChiTietKhoDeNghiXuatKho.length > 0)
					this.tmpChiTietKhoDeNghiXuatKho.forEach(row => { row.listNewBPSD = this.listBP; });
				this.changeDetectView();
			};
		});
	}

	// ---< Search bộ phận sử dụng >----------------------------------------  
	// ---< index: < 0 form Master | index >=0 từ chi tiết
	filterNewBPSD(index = -1) {
		if (!this.listBP) return;
		let search = index < 0 ? this.BPFilterCtrl : this.tmpChiTietKhoDeNghiXuatKho[index].searchNewPSD;
		if (!search) {
			if (index < 0) this.filteredBP.next(this.listBP.slice());
			if (index >= 0) this.tmpChiTietKhoDeNghiXuatKho[index].listNewBPSD = this.listBP.slice();
		}
		search = search.toLowerCase();
		if (index < 0) {
			this.filteredBP.next(
				this.listBP.filter(ts =>
					ts.TenPB.toLowerCase().indexOf(search) > -1)
			);
		}
		if (index >= 0) {
			let listWithSearch = this.listBP.filter(ts => ts.TenPB.toLowerCase().indexOf(search) > -1);
			this.tmpChiTietKhoDeNghiXuatKho[index].listNewBPSD = listWithSearch;
		}
		this.changeDetectView();
	}

	// ---< Xóa bộ phận sử dụng >----------------------------------------- 
	clearNewBPSD(event: any) {
		this.KhoDeNghiXuatKhoSubForm.controls["DIVISION"].setValue('');
		event.stopPropagation();
		this.changeDetectView();
	}

	// #region Chèn hàng hóa từ BOM
	// .. Binding data from BOM
	bindingFromBOM() {
		const form = this.KhoDeNghiXuatKhoForm.controls;
		if (this.data.data.length > 0) {
			this.tmpChiTietKhoDeNghiXuatKho = [];
			this.tmpChiTietKhoDeNghiXuatKho = [...this.data.data];
			this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];
		}
		this.progressBar.next(false);
		
		//#region Load form
		const type = this.typeOptions.find(x => x.Ma == this.data.optionTypeCode);
		const typeId = type ? type.Id.toString() : CONFIGURATION.REQUEST_EXPORT_TYPE_DEFAULT;
		form["GHICHU"].setValue("Xuất kho cho " + this.data.data[0].NameNewBPSD);
		form["LOAIPHIEU"].setValue(typeId);
		form["LYDOXUAT"].setValue(this.data.optionReasonCode);
		//#endregion

		this.changeDetectView();
	}
	// .. Xử lý liên quan danh sách đon vị tính
	bindingUnits(dataMer) {
		let result = [];
		switch (true) {
			case (dataMer.Dvt3 && dataMer.Dvt3 > 0):
				{
					result.push({
						DVT: dataMer.Dvt3,
						QuiDoiDVT: dataMer.QuiDoiDVT3,
						TenDVT: dataMer.TenDVT3
					});
				}
			case (dataMer.Dvt2 && dataMer.Dvt2 > 0):
				{
					result.push({
						DVT: dataMer.Dvt2,
						QuiDoiDVT: dataMer.QuiDoiDVT2,
						TenDVT: dataMer.TenDVT2
					});
				}
			default:
				{
					result.push({
						DVT: dataMer.DVT,
						QuiDoiDVT: 1,
						TenDVT: dataMer.TenDVT
					});
				}
		}
		result = result.filter(x => x.DVT) // remove null
		result = result.filter((e, i) => (result.map(x => x.DVT)).indexOf(e.DVT) === i);
		return result;
	}
	// .. Kiểm tra control có required
	isRequiredControl(controlName) {
		return this.KhoDeNghiXuatKhoSubForm.get(controlName).validator.length > 0;
	}
	//#endregion

	// #region Format Number
	// .. Hàm sử dụng cho sự kiện change format số trên form
	cvInputFormNumber(controlName: string, event: any, min: number = 0, formGroup) {
		const VALUE_EMPTY = "";
		const MIN_VALUE = min;
		const REGEX_COMMA = /,/g;
		const VALUE_DEFAULT = 0.00000;
		var controls = formGroup.controls;
		var valueControl = controls[controlName].value;
		// .. Giá trị trống thì lấy giá trị min
		if (valueControl == VALUE_EMPTY) controls[controlName].setValue(this.f_number(MIN_VALUE));
		// .. Giá trị không xác thực gán lại 0.0
		if (isNaN(valueControl)) valueControl = VALUE_DEFAULT;
		// .. Giá trị nhỏ hơn min thì = min
		if (Number(valueControl) < min) valueControl = MIN_VALUE;
		// .. Valid mới set giá trị
		if (!controls[controlName].invalid) controls[controlName].setValue(this.f_number(valueControl));
		// .. Giá trị "," thì gán về min
		if (valueControl.toString().indexOf(REGEX_COMMA) == 0 && valueControl.length == 1) valueControl = MIN_VALUE;
		controls[controlName].setValue(this.f_number(valueControl));
	}
	// .. Hàm sử dụng cho sự kiện change format số trên table
	cvInputListNumber(columnName: string, event: any, min: number = 0, item: KhoDeNghiXuatKhoPageChiTiet) {
		const VALUE_EMPTY = "";
		const MIN_VALUE = min;
		const REGEX_COMMA = /,/g;
		const INDEX_ZERO = 0;
		const VALUE_DEFAULT = 0.00000;
		var value = item[columnName];
		var evtValue = event.target.value;
		var evtTarget = event.target;
		if ((evtValue == VALUE_EMPTY) || (evtValue.toString() == value.toString())) {
			if (evtValue == VALUE_EMPTY) evtTarget.value = this.f_number(MIN_VALUE);
			if (evtValue.toString() == value.toString()) evtTarget.value = this.f_number(value);
			evtTarget.selectionStart = INDEX_ZERO;
			evtTarget.selectionEnd = INDEX_ZERO;
		}
		if (!this.ValidateChangeNumberForm(event)) {
			item[columnName] = MIN_VALUE;
			return false;
		}
		if (isNaN(evtValue)) evtValue = VALUE_DEFAULT;
		if (Number(evtValue) < min) evtValue = MIN_VALUE;
		if (!item[columnName]) item[columnName] = MIN_VALUE;
		item[columnName] = evtValue;
		evtTarget.value = this.f_number(evtValue);
		this.changeDetect.detectChanges();
	}
	// .. Điều chỉnh hàm format
	f_number(item: any = "0.00000") {
		return FunctionPublic.F_NUMBER_DYNAMIC(item, FunctionPublic.MAX_POINT);
	}
	// #endregion

	// .. Tải file mẫu
	downloadTemplateImport() {
		this.loadingDownloadTemplate.next(true);
		this.KhoDeNghiXuatKhoService.downloadTemplateImport().subscribe((blob) => {
			var downloadLink = document.createElement("a");
			var url = URL.createObjectURL(blob);
			downloadLink.href = url;
			downloadLink.download = "FILE_MAU_DENGHIXUATKHO";
			document.body.appendChild(downloadLink);
			downloadLink.click();
			document.body.removeChild(downloadLink);
			this.loadingDownloadTemplate.next(false);
			this.changeDetectView();
		});
	}
	// .. Mở cửa sổ chọn file
	openSelectFile() {
		if (this.tmpChiTietKhoDeNghiXuatKho.length > 0) {
			const dialogRef = this.layoutUtilsService.POPConfirm("Bạn có muốn xóa hết thông tin chi tiết trước khi chọn file ?");
			dialogRef.afterClosed().subscribe(res => {
				if (res) {
					this.tmpChiTietKhoDeNghiXuatKho = [];
					this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];
					this.bindValueDienGiai()
				}
				var inputFile: HTMLElement = this.fileUploadImport.nativeElement as HTMLElement;
				inputFile.click();
			});
		}
		else {
			var inputFile: HTMLElement = this.fileUploadImport.nativeElement as HTMLElement;
			inputFile.click();
		}
	}
	// .. Xác thực file
	validateFileSelected(evt: any) {
		if (evt.target.files && evt.target.files.length) {
			const EXTENSION_VALID = ".xlsx";
			let file = evt.target.files[0];
			let fileName = file.name;
			var res = fileName.match(/.xlsx$/g);
			var error = 'File không hợp lệ, chỉ nhận file định dạng xlsx';
			if (!res || !res["includes"](EXTENSION_VALID)) {
				this.layoutUtilsService.showErorr(error);
				return;
			}
			this.startImportFile();
		}
		evt.target.type = 'text';
		evt.target.type = 'file';
	}
	// .. Lấy dữ liệu file đã chọn, xử lý, gửi đến server
	startImportFile() {
		var id: any = this.fileUploadImport.nativeElement;
		var service = this.KhoDeNghiXuatKhoService;
		for (var idx = 0; idx < id.files.length; idx++) {
			this.loadingImportFile.next(true);
			var extension = id.files[idx].name.split(".").pop();
			var indexExtension = id.files[idx].name.indexOf(extension);
			var fileName = id.files[idx].name.substring(0, indexExtension - 1);
			var data = { fileName: fileName, extension: extension };
			var reader = new FileReader();
			var changeView = this.changeDetect;
			var self = this;
			reader.readAsDataURL(id.files[idx]);
			reader.onload = function () {
				var base64Str = reader.result as String;
				var metaIdx = base64Str.indexOf(";base64,");
				base64Str = base64Str.substring(metaIdx + 8);
				data = { ...data, ...{ base64: base64Str } };
				service.startImportFile(data).subscribe((res) => {
					self.afterImportExcel(res);
					changeView.detectChanges();
				});
			};
		}
	}
	// .. Hàm xử lý sau khi upload file & nhận json từ server
	afterImportExcel({ status, data }) {
		if (status == 0) {
			this.loadingImportFile.next(false);
			this.layoutUtilsService.showErorr("Lỗi: không thể import file.");
			return;
		}
		const ROW_START = 5;
		var _errors = [];
		var _beforeOptionsDivision = this.optionsDivision;
		if (data.data && data.data.length > 0) {
			data.data.forEach((_x, _index) => {
				var _isError = false;
				var _item = new KhoDeNghiXuatKhoPageChiTiet();
				_item.clear();
				_item.IdHh = _x.IdHh ? Number(_x.IdHh) : 0;
				_item.MaHH = _x.MaHH || "";
				_item.TenHH = _x.TenHH || "";
				_item.QuyCach = _x.QuyCach;
				_item.Dvt = _x.Dvt ? Number(_x.Dvt) : 0; // .. Đơn vị tính cấp 1
				_item.TenDvt = _x.TenDvt || '';
				_item.DvtQuiDoi = _x.DvtQuiDoi ? Number(_x.DvtQuiDoi) : 0; // .. Đơn vị tính excel
				_item.SoLuongQuiDoi = _x.SoLuongQuiDoi ? Number(_x.SoLuongQuiDoi) : 0; // .. Số lượng excel
				_item.Soluong = _x.Soluong ? Number(_x.Soluong) : 0; // .. Số lượng của đơn vị tính cấp 1
				_item.NgayCan = _x.NgayCan ? moment(_x.NgayCan).format("YYYY-MM-DD") : null;
				_item.MucDichSuDung = _x.MucDichSuDung || "";
				_item.BPDN = _x.BPDN ? Number(_x.BPDN) : 0; // .. Phòng ban đề nghị
				_item.BPSD = _x.BPSD ? Number(_x.BPSD) : 0; // .. Phòng ban sử dụng
				_item.SoLo = _x.SoLo || "";
				_item.SLThucXuat = 0.0;
				_item.TenBPDN = _x.TenBPDN || "";
				_item.TenBPSD = _x.TenBPSD || "";
				_item.GhiChu = this.KhoDeNghiXuatKhoForm.controls["GHICHU"].value;
				_item.IdKh = _x.IdKh ? Number(_x.IdKh) : 0;
				_item.MaKH = _x.MaKH || "";
				_item.TenKH = _x.TenKH || "";
				_item.searchNewPSD = "";
				_item.listNewBPSD = this.listBP;
				_item.DoiTuongTHCP = _x.DoiTuongTHCP ? Number(_x.DoiTuongTHCP) : 0;
				_item.TenDoiTuongTHCP = _x.TenDoiTuongTHCP ? _x.TenDoiTuongTHCP : "";
				_item.SoMayArr = _x.SoMay ? [_x.SoMay] : [];
				_item.SXSMArr = _x.SXSM ? [_x.SXSM] : [];
				_item.MaThungArr = _x.MaThung ? [_x.MaThung] : [];
				_item.NSXArr = _x.NSX ? [_x.NSX] : [];
				_item.HSDArr = _x.HSD ? [_x.HSD] : [];
				_item.OptionsSoMay = _x.OptionsSoMay || [];
				_item.OptionsSMSX = _x.OptionsSMSX  || [];
				_item.OptionsNSX = _x.OptionsNSX || [];
				_item.OptionsHSD = _x.OptionsHSD || [];
				_item.OptionsMaThung = _x.OptionsMaThung || [];

				// Kiểm tra lỗi import cột Bộ phận sử dụng
				if (_item.BPSD) {
					this.loadDivisionOptions(_x.BPSD || "");
					var _optionDivision = this.optionsDivision.map(_option => Number(_option.Id_PB));
					if (!_x.NewBPSD) {
						const _messgeError = "Trường Bộ phận sử dụng bắt buộc chọn khi đã chọn Phòng ban sử dụng; ";
						_errors.push({
							row: (_index + ROW_START),
							message: [_messgeError]
						})
						_isError = true;
					} else {
						if (_optionDivision.includes(Number(_x.NewBPSD))) {
							_item.NewBPSD = _x.NewBPSD ? Number(_x.NewBPSD) : 0; // .. Bộ phận sử dụng
							_item.NameNewBPSD = _x.NameNewBPSD || "";
						} else {
							const _notMappingError = "Trường Bộ phận sử dụng đã chọn không thuộc Phòng ban sử dụng đã chọn; "
							_errors.push({
								row: (_index + ROW_START),
								message: [_notMappingError]
							})
							_isError = true;
						}
					}
				}
				if (!_isError) this.tmpChiTietKhoDeNghiXuatKho.push(_item);
			});
		}
		_errors.forEach(_error => {
			const _rowError = data.errors.find(_err => _err.row == _error.row);
			if (!_rowError) {
				data.errors.push(_error);
			} else {
				_rowError.message.push(_error.message);
			}
		})

		if (data.errors && data.errors.length > 0) {
			data.errors.sort((a, b) => {
				return a.row - b.row;
			});
			this.layoutUtilsService.warningImportDNXK(data.errors);
		}
		this.loadingImportFile.next(false);
		this.layoutUtilsService.showInfo("Import thành công!");
		this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];
		this.optionsDivision = _beforeOptionsDivision;
		this.bindValueDienGiai();
    if (this.tmpChiTietKhoDeNghiXuatKho.length > 0 && this.tmpChiTietKhoDeNghiXuatKho[0].IdKh) {
        this.afterSelectKH(this.tmpChiTietKhoDeNghiXuatKho[0].IdKh.toString());
    }
		this.changeDetectView();
	}
	bindValueDienGiai() {
		var dataMap = [];
		let dataDienGiai = 'Xuất kho cho ';
		var data = this.dataTree.value && this.dataTree.value.length > 0 ? this.dataTree.value[0] : null;

		this.tmpChiTietKhoDeNghiXuatKho.forEach(element => {

			if (element.IdKh > 0) {
				dataMap.push(this.getTenKh(element.IdKh))
			}
			else if (element.IdKh == null && element.NewBPSD > 0) {
				dataMap.push(this.fetchDepartmentName(data, element.NewBPSD))
			}
			else {
				dataMap.push(this.fetchDepartmentName(data, element.BPSD))
			}

		});
		if (dataMap.length > 0) {
			this.KhoDeNghiXuatKhoForm.controls["GHICHU"].setValue(dataDienGiai + [...new Set(dataMap)].join(' , '));
		}
		else {
			this.KhoDeNghiXuatKhoForm.controls["GHICHU"].setValue('');
		}

	}
	getTenKh(item) {
		if (item) {
			let obj = this.listId_KH.find(x => x.IdKh == item);
			return obj ? obj.Tenkh : '';
		}
		return '';
	}
	getNewBPSD(item) {
		if (item) {
			let obj = this.listBP.find(x => x.Id_PB == item);
			return obj ? obj.TenPB : '';
		}
		return '';
	}
	getBPSD(item) {
		if (item) {
			let obj = this.listListBP.find(x => x.Id_PB == item);
			return obj ? obj.TenPB : '';
		}
		return '';
	}
	// .. Scroll lên đầu trang
	scrollToTop() {
		setTimeout(() => {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}, 200);
	}
	// .. Chỉnh sửa dữ liệu chi tiết
	editItem(index: number) {
		if (index > -1) {
			var row = { ...this.tmpChiTietKhoDeNghiXuatKho[index] };
			// .. Lấy danh sách data hàng hóa
			this.Id_HHFilterCtrl = row.MaHH;
			this.keywordChanged.next(this.Id_HHFilterCtrl);
			this.objTHCPFilterCtrl = row.DoiTuongTHCP ? row.TenDoiTuongTHCP.split("-")[0].trim() : "";
			this.searchObjTHCP.next(this.objTHCPFilterCtrl);
			if (row.BPSD) this.loadDivisionOptions(row.BPSD + '');
			this.scrollToTop();
			setTimeout(() => {
				// .. Khai báo form
				var formControl = this.KhoDeNghiXuatKhoSubForm.controls;
				var maserControl = this.KhoDeNghiXuatKhoForm.controls;
				// .. Fill data 
				formControl["MAHH"].setValue(Number(row.IdHh));
				formControl["TENHH"].setValue(row.TenHH);
				formControl["QUYCACH"].setValue(row.QuyCach);
				formControl["DVTQuiDoi"].setValue(row.TenDvt);
				formControl["SLTON"].setValue(this.f_number(this.getTotalWeight(Number(row.IdHh))));
				formControl["SoLuongQuiDoi"].setValue(Number(row.SoLuongQuiDoi));
				formControl["BPDN"].setValue('' + row.BPDN);
				formControl["BPSD"].setValue('' + (row.BPSD ? row.BPSD : ''));
				formControl["DIVISION"].setValue('' + (row.NewBPSD ? +row.NewBPSD : ''));
				formControl["NGAYCAN"].setValue(row.NgayCan);
				formControl["SOLO"].setValue(row.SoLo);
				formControl["SOMAY"].setValue(row.SoMayArr);
				formControl["SOMEXE"].setValue(row.SXSMArr);
				formControl["MUCDICHSUDUNG"].setValue(row.MucDichSuDung);
				formControl["NSX"].setValue(row.NSXArr);
				formControl["HSD"].setValue(row.HSDArr);
				formControl["MATHUNG"].setValue(row.MaThungArr);
				if (row.DoiTuongTHCP) {
					formControl["OBJTHCP"].setValue(Number(row.DoiTuongTHCP));
				} else {
					formControl["OBJTHCP"].enable();
				}
				if (row.IdKh) this.afterSelectKH('' + row.IdKh);
				this.selectId_HH = "" + row.IdHh;
				this.selectObjTHCP = (row.DoiTuongTHCP != null ? row.DoiTuongTHCP.toString() : '');
				this.rowUpdate = index;
				//this.setListUnitFromIdHH(Number(row.IdHh));
				this.cvInputFormNumber('SoLuongQuiDoi', null, 0, this.KhoDeNghiXuatKhoSubForm);
				this.changeDetectView();
				this.idCusBeforeAmended = row.IdKh ? Number(row.IdKh) : -1;
				// .. Reload list
				this.reloadListDataFromIdHH();
				formControl["SOLO"].enable();
				formControl["SOMAY"].enable();
				formControl["SOMEXE"].enable();
				formControl["NSX"].enable();
				formControl["HSD"].enable();
				formControl["MATHUNG"].enable();
			}, 1000);
		}
		this.changeDetectView();
	}
	// .. Lấy số lượng tồn theo idhh
	getTotalWeight(idhh: number) {
		if (!idhh || !this.listId_HH || this.listId_HH.length == 0) return 0;
		var _item = this.listId_HH.find(_x => _x.Id_HH == idhh);
		if (!_item) return 0;
		return Number(_item.TongSoLuongTon);
	}
	// .. Lấy danh sách dvt theo idhh
	setListUnitFromIdHH(idhh: number) {
		var listDVTs = []
		if (idhh < 0 || !this.listId_HH || this.listId_HH.length == 0) return listDVTs;
		if (idhh > -1 && this.listId_HH.length > 0)
			var item = this.listId_HH.find(_x => _x.Id_HH == idhh);
		if (!item) return listDVTs;
		if (item != null)
			listDVTs.push(item.DVT);
		if (item.Dvt2 != null && item.Dvt2 > 0) listDVTs.push(item.Dvt2);
		if (item.Dvt3 != null && item.Dvt3 > 0) listDVTs.push(item.Dvt3);
		this.filteredListDVT.next(this.listDVT.filter(ts => listDVTs.reverse().indexOf(ts.Id_DVT) > -1));
	}
	// .. Update data dòng 
	updateDataRow(_newData: KhoDeNghiXuatKhoPageChiTiet) {
		if (this.rowUpdate < 0) return;
		var _item = this.tmpChiTietKhoDeNghiXuatKho[this.rowUpdate];
		_item.IdHh = _newData.IdHh;
		_item.MaHH = _newData.MaHH;
		_item.TenHH = _newData.TenHH;
		_item.QuyCach = _newData.QuyCach;
		_item.Dvt = _newData.Dvt;
		_item.TextQuiDoiDVT = _newData.TextQuiDoiDVT;
		_item.ListHH = _newData.ListHH;
		_item.DvtQuiDoi = _newData.DvtQuiDoi;
		_item.SoLuongQuiDoi = _newData.SoLuongQuiDoi;
		_item.Soluong = _newData.Soluong;
		_item.NgayCan = _newData.NgayCan;
		_item.MucDichSuDung = _newData.MucDichSuDung;
		_item.BPDN = _newData.BPDN;
		_item.BPSD = _newData.BPSD;
		_item.NewBPSD = _newData.NewBPSD;
		_item.SoLo = _newData.SoLo;
		_item.SLThucXuat = _newData.SLThucXuat;
		_item.SoMayArr = _newData.SoMayArr;
		_item.TenBPDN = _newData.TenBPDN;
		_item.TenBPSD = _newData.TenBPSD;
		_item.NameNewBPSD = _newData.NameNewBPSD;
		_item.GhiChu = _newData.GhiChu;
		_item.IdKh = _newData.IdKh;
		_item.MaKH = _newData.MaKH;
		_item.TenKH = _newData.TenKH;
		_item.searchNewPSD = _newData.searchNewPSD;
		_item.listNewBPSD = _newData.listNewBPSD;
		_item.DoiTuongTHCP = _newData.DoiTuongTHCP;
		_item.TenDoiTuongTHCP = _newData.TenDoiTuongTHCP;
		_item.SXSMArr = _newData.SXSMArr;
		_item.NSXArr = _newData.NSXArr;
		_item.HSDArr = _newData.HSDArr;
		_item.MaThungArr = _newData.MaThungArr;
		// .. Remove and Add again
		this.tmpChiTietKhoDeNghiXuatKho.splice(this.rowUpdate, 1);
		this.tmpChiTietKhoDeNghiXuatKho.splice(this.rowUpdate, 0, _item);
	}
	// .. Reset form về mặc định
	resetFormControl() {
		const subForm = this.KhoDeNghiXuatKhoSubForm;
		setTimeout(() => {
			this.requireDepartmentInUse.next(false);
			this.requireDivisionInUse.next(false);
			subForm.controls["MAHH"].setValue("");
      subForm.controls["TENHH"].setValue("");
      subForm.controls["DVTQuiDoi"].setValue("");
			this.selectId_HH = "";
			this.listMachineCode = [];
			this.selectListSPDHB = "";
			this.textQuiDoiDVT = "";
			this.selectObjTHCP = "";
			subForm.controls["MAHH"].enable();
			subForm.controls["SLTON"].setValue(FunctionPublic.TEXT_MIN_POINT);
			subForm.controls["NGAYCAN"].setValue(new Date());
			subForm.controls["SoLuongQuiDoi"].setValue(FunctionPublic.TEXT_MIN_POINT);
			subForm.controls["MUCDICHSUDUNG"].setValue("");
			subForm.controls["BPDN"].setValue('');
			subForm.controls["BPSD"].setValue('');
			subForm.controls["DIVISION"].setValue('');
			subForm.controls["OBJTHCP"].disable();
			this.requireDepartmentInUse.next(true);
			this.requireDivisionInUse.next(true);
		}, 0);
		this.clearObjTHCP();
		this.sumRecord = this.listId_HH.length;
		this.filteredId_HH.next(this.listId_HH.slice());
    this.Id_HHFilterCtrl = "";
    this.keywordChanged.next("");
		if (this.idCusBeforeAmended > -1) {
			this.afterSelectKH(this.idCusBeforeAmended + "");
			this.idCusBeforeAmended = -1;
		}
		this.changeDetectView();
	}
	// .. Handle dữ liệu từ Nhập liệu sản xuất truyền qua
	handleDataNLSXSource(data) {
		const CONSTANT_DIGITS = ",00";
		const CONSTANT_NULL = null;
		const CONSTANT_EMPTY = "";
		const CONSTANT_ARRAY_EMPTY = [];
		const CONSTANT_COMMA = ",";

		// .. Đọc dữ liệu truyền
		this.KhoDeNghiXuatKhoItem = data;
		// .. Xử lý lại data
		var ids = this.KhoDeNghiXuatKhoItem.ChiTiet.map(x => Number(x.IdHh)).join(CONSTANT_COMMA);
		var ids = ids + CONSTANT_COMMA;
		this.commonService.top_list_of_merchandise(ids, 0).subscribe((res) => {
			if (res && res.status === 1) {
				var list = [];
				this.KhoDeNghiXuatKhoItem.ChiTiet.forEach(item => {
					var merChandise = res.data.find(_x => _x.Id_HH == item.IdHh);
					if (merChandise != null) {
						var detail = new KhoDeNghiXuatKhoPageChiTiet();
						detail.clear();
						detail.IdHh = merChandise.Id_HH;
						detail.MaHH = merChandise.MaHH;
						detail.TenHH = merChandise.TenHH;
						detail.QuyCach = merChandise.QuyCach;
						detail.NgayCan = item.NgayCan;
						detail.MucDichSuDung = item.MucDichSuDung;
						detail.BPDN = item.BPDN;
						detail.BPSD = item.BPSD;
						detail.NewBPSD = CONSTANT_NULL;
						detail.SoLo = CONSTANT_EMPTY;
						detail.SLThucXuat = item.SLThucXuat;
						detail.SoMayArr = merChandise.CodeMachines.split(",");
						detail.searchNewPSD = CONSTANT_EMPTY;
						detail.listNewBPSD = this.listBP;
						detail.GhiChu = this.KhoDeNghiXuatKhoForm.controls["GHICHU"].value;
						detail.ListHH = this.bindingUnits(merChandise);
						// .. Tính toán quy đổi
						var redeem = this.calRedeem(detail.ListHH, item.Soluong, item.Dvt);
						var sysInit = detail.ListHH && detail.ListHH.length > 0 ? detail.ListHH.reverse()[0] : [];
						const SYSUNITID = 83;
						const SYSUNITNAME = "kg";
						detail.Dvt = sysInit.length ? sysInit.DVT : SYSUNITID;
						detail.TextQuiDoiDVT = item.Soluong + CONSTANT_DIGITS + sysInit.length ? sysInit.TenDVT : SYSUNITNAME;
						detail.DvtQuiDoi = item.Dvt;
						detail.SoLuongQuiDoi = item.Soluong;
						detail.Soluong = redeem;
						if (this.selectedId_KH != 0) {
							detail.IdKh = Number(this.selectedId_KH);
							detail.MaKH = this.listId_KH.find(x => x.IdKh == item.IdKh).Makh;
							detail.TenKH = this.KhoDeNghiXuatKhoForm.controls["TenKhachHang"].value;
						}
						else {
							detail.IdKh = null;
							this.KhoDeNghiXuatKhoForm.controls["GHICHU"].setValue("");
						}
						list.push(detail);
					}
				});
				if (list.length > 0) {
					this.tmpChiTietKhoDeNghiXuatKho = CONSTANT_ARRAY_EMPTY;
					this.tmpChiTietKhoDeNghiXuatKho = [...list];
					this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];
				}
			}
			this.KhoDeNghiXuatKhoForm.controls["GHICHU"].setValue(this.KhoDeNghiXuatKhoItem.Ghichu);
			this.progressBar.next(false);
			this.KhoDeNghiXuatKhoForm.disable();
			this.isFromNLSX = true;
			this.changeDetectView();
		});
	}
	// ......................................................................
	// .. Xử lý giá trị quy đổi sang kg
	calRedeem(arrUnits: any[], inRedeem: number, inUnit: number) {
		var outRedeem = 0;
		arrUnits.forEach(arrUnit => {
			if (arrUnit.DVT == inUnit)
				outRedeem = Number(arrUnit.QuiDoiDVT) * Number(inRedeem);
		})
		return outRedeem;
	}
	// .. Dialog Form
	handleFormDialog() {
		const CONSTANT_COMMA = ",";
		var form = this.KhoDeNghiXuatKhoForm.controls;
		// .. Custom UI
		this.isPageForm.next(false);
		this.dialogRef.updateSize('90vw', '90vh');
		// .. Lấy số phiếu mới
		this.createBillNumber().then((r) => { form["SOPHIEU"].setValue(r); });
		this.progressBar.next(true);
		
		if (this.data.isSourceBOM) {
			this.bindingFromBOM();
		} else {
			this.isFromNLSX = true;
			this.handleDataNLSXSource(this.data.data);
		}
	}
	// .. Điều hướng quay lại
	routerBack(isClosePopup = false) {
		if (this.isPageForm.value)
			this.router.navigateByUrl('de-nghi-xuat-kho', { relativeTo: this.activatedRoute });
		else
			this.dialogRef.close({isClosePopup: isClosePopup});
	}
	// .............................................................
	// .. Đối tượng THCP
	ListObjTHCP(keyword: string = "", top: number = 0) {
		const THANHPHAM = 4;
		this.loadingObjTHCP.next(true);
		this.spinnerHH = true;
		//this.KhoDeNghiXuatKhoSubForm.controls["OBJTHCP"].disable();
		this.commonService.top_list_of_merchandise_lite(keyword, top).subscribe((res) => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listObjTHCP = res.data;
				this.filteredObjTHCP.next(this.listObjTHCP.slice());
				//this.KhoDeNghiXuatKhoSubForm.controls["OBJTHCP"].enable();
			}
			this.changeDetect.detectChanges();
			this.loadingObjTHCP.next(false);
			this.loadingSubject.next(true);
		});
	}
	filterObjTHCP() {
		this.searchObjTHCP.next(this.objTHCPFilterCtrl);
		this.changeDetectView();
	}
	changeObjTHCP(value: string) {
		let controls = this.KhoDeNghiXuatKhoSubForm.controls;
		this.listObjTHCP.forEach((obj) => {
			if (obj.Id_HH == +value) {
				this.selectObjTHCP = value;
				controls["OBJTHCP"].setValue(obj.MaHH);
				controls["OBJTHCP"].disable();
			}
		});
	}
	nameOfObjTHCP(onlyCode: boolean = true) {
		if (!this.listObjTHCP || this.listObjTHCP.length == 0) return "";
		var obj = this.listObjTHCP.find(x => x.Id_HH == Number(this.selectObjTHCP));
		return (!this.selectObjTHCP || !obj) ? "" : (onlyCode ? obj.MaHH : obj.MaHH + " - " + obj.TenHH);
	}
	clearObjTHCP() {
		let controls = this.KhoDeNghiXuatKhoSubForm.controls;
		this.filterObjTHCP();
		this.selectObjTHCP = "";
		this.objTHCPFilterCtrl = "";
		this.searchObjTHCP.next(this.objTHCPFilterCtrl);
		controls["OBJTHCP"].setValue("");
		this.filteredObjTHCP.next(this.listObjTHCP.slice());
		controls["OBJTHCP"].enable();
		this.changeDetect.detectChanges();
	}
	// .............................................................
	// .. Lấy dánh sách lý do xuất
	listReasonsWarehouse() {
		this.commonService
			.listReasonsWarehouse(CONFIGURATION.CODE_FORM)
			.subscribe(res => {
				if (!res || res.status == 0) {
					this.layoutUtilsService.showErorr(ERROR_MESSAGES.ERROR_CONNECT_API);
					return;
				}
				if (res.data.length == 0) {
					this.layoutUtilsService.showErorr(ERROR_MESSAGES.ERROR_LIST_EMPTY);
					return;
				}
				this.arrReason = res.data;
				this.arrReason.push(CONFIGURATION.OTHER_REASONS);
				// .. Xử lý lý do xuất
				const form = this.KhoDeNghiXuatKhoForm.controls;
				const detail = this.KhoDeNghiXuatKhoItem;
				if (form) {
					if (!detail.IdDn) {
						form['LYDOXUAT'].setValue(this.fStr(this.arrReason[0].key));
					}
					else {
						if (!detail.Lydocode) {
							form['LYDOXUAT'].setValue(CONFIGURATION.OTHER_REASONS.key);
							form['LYDOKHAC'].setValue(detail.Lydo);
						}
						else
							form['LYDOXUAT'].setValue(detail.Lydo);
					}
					this.changeReason(form['LYDOXUAT'].value);
				}
				this.changeDetectView();
			})
	}
	// .. Xử lý thay đổi Lý do xuất
	changeReason(value) {
		var key = value;
		let form = this.KhoDeNghiXuatKhoForm.controls;
		let subForm = this.KhoDeNghiXuatKhoSubForm.controls;

		// .. Xử lý cho lý do 'Xuất cho BP sử dụng'		
		if (key && key == CONFIGURATION.ENABLE_REQUIRED.key) {
			subForm[CONFIGURATION.ENABLE_REQUIRED.value].setValidators([Validators.required]);
			this.requireDivisionInUse.next(true);
		} else {
			this.requireDivisionInUse.next(false);
			subForm[CONFIGURATION.ENABLE_REQUIRED.value].clearValidators();
		}
		subForm[CONFIGURATION.ENABLE_REQUIRED.value].updateValueAndValidity();

		// .. Xử lý do lý do 'Khác'
		if (key && key.includes(CONFIGURATION.OTHER_REQUIRED.key)) {
			form[CONFIGURATION.OTHER_REQUIRED.value].setValidators([Validators.required]);
			setTimeout(() => this.otherReason.first.nativeElement.focus(), 500);
		}
		else {
			form[CONFIGURATION.OTHER_REQUIRED.value].clearValidators();
			form[CONFIGURATION.OTHER_REQUIRED.value].setValue("");
		}
		form[CONFIGURATION.OTHER_REQUIRED.value].updateValueAndValidity();

		// .. Nếu loại phiếu 'Xuất sử dụng' và Lý do xuất 'Xuất cho hoạt động sản xuất' bắt buộc chọn đối tượng THCP
		this.updateRequiredFieldsForObjTHCP();

		this.changeDetectView();
	}
	// .. Lấy thông tin số mẻ/số xe theo hàng hóa
	getSMSXFormIdHH(idhh) {
		let item = this.listId_HH.find(x => x.Id_HH == idhh);
		if (!item || item.length == 0) return [];
		return this.isNullEmptyArr(item.SoXeSoMe) ? [] : item.SoXeSoMe.split(",");
	}
	// .. Kiểm tra mảng null or empty
	isNullEmptyArr(arr) {
		if (!arr || arr.length == 0) return true;
		return false;
	}
	// .. reload danh sách số máy và số xe số mẻ
	reloadListDataFromIdHH() {
		this.listId_HH.forEach(el => {
			if (el.Id_HH == +this.selectId_HH) {
				// .. Set data vào dánh sách
				this.listMachineCode = this.isNullEmptyArr(el.CodeMachines) ? [] : el.CodeMachines.split(",");
				this.batchQuantityList = this.isNullEmptyArr(el.SoXeSoMe) ? [] : el.SoXeSoMe.split(",");
				this.manufacturingDateList = this.isNullEmptyArr(el.NgaySanXuat) ? [] : el.NgaySanXuat.split(",");
				this.expirationDateList = this.isNullEmptyArr(el.HanSuDung) ? [] : el.HanSuDung.split(",");
				this.containerCodeList = this.isNullEmptyArr(el.MaThungTP) ? [] : el.MaThungTP.split(",");
			}
		});
		this.changeDetect.detectChanges();
	}
	// .. kiểm tra check chọn lý do khác
	isSelectedOtherReason() {
		let form = this.KhoDeNghiXuatKhoForm.controls;
		let value = form["LYDOXUAT"].value;
		return value && CONFIGURATION.OTHER_REASONS.key.includes(value);
	}
	// .............................................................
	validateForm(details) {
		const form = this.KhoDeNghiXuatKhoForm;
		const ctrForm = form.controls;

		// .. Check validate form
		if (form.invalid) {
			const element = this.el.nativeElement.querySelectorAll(".ng-invalid");
			if (element.length > 0) {
				element.forEach((x, i) => {
					if (["INPUT", "MAT-SELECT"].includes(x.nodeName)) {
						let attr = x.attributes.getNamedItem("formcontrolname").value;
						if (form.get(attr)) {
							setTimeout(() => x.focus(), 100);
							return;
						}
					}
				})
			}
			Object.keys(ctrForm).forEach((controlName) =>
				ctrForm[controlName].markAsTouched()
			);
			this.hasFormErrors = true;
			return false;
		}

		// .. Check if the details array is empty
		if (details.length == 0) {
			this.layoutUtilsService.showErorr(ERROR_MESSAGES.ERROR_DETAILS_EMPTY);
			return false;
		}

		// .. Cảnh báo lỗi từng dòng chi tiết
		const rowsError = details
			.filter((element, index) => {
				// Verify Bộ phận vị trí
				const isSelectedDivisionInUse = ctrForm["LYDOXUAT"].value == CONFIGURATION.ENABLE_REQUIRED.key;
				const invalidSelectedDivisionInUse = isSelectedDivisionInUse ? !element.NewBPSD : false;
				// Verify Phòng ban sử dụng
				const isSelectedDepartmentInUse = ctrForm["LOAIPHIEU"].value == CONFIGURATION.BPSD_REQUIRED.value;
				const invalidSelectedDepartmentInUse = isSelectedDepartmentInUse ? !element.BPSD : false;
				// Verify Đối tượng THCP
				const isSelectedObjTHCP = this.requiredFieldForObjTHCP();
				const invalidSelectedObjTHCP = isSelectedObjTHCP ? !element.DoiTuongTHCP : false;
				// Reurn validate
				return element.SoLuongQuiDoi <= 0
					|| !element.SoLuongQuiDoi
					|| !element.NgayCan
					|| invalidSelectedDivisionInUse
					|| invalidSelectedDepartmentInUse
					|| invalidSelectedObjTHCP;
			})
			.map((_, index) => index + 1);

		if (rowsError.length > 0) {
			this.layoutUtilsService.showErorr(ERROR_MESSAGES.ERROR_DETAILS_INVALID + rowsError.join(","));
			return false;
		}

		// .. Cảnh báo lỗi tồn tại hàng hóa đã bị xóa khỏi hệ thống
		const disabledProducts = details.filter((element, index) => {
			return element.ProductDisabled
		}).map((_, index) => index + 1);

		if (disabledProducts.length > 0) {
			this.layoutUtilsService.showErorr(ERROR_MESSAGES.ERROR_PRODUCT_DISABLED + disabledProducts.join(","));
			return false;
		}

		return true;
	}
	// .............................................................
	// .. Lấy nội dung lý do xuất kho
	takeValueSelectedReason() {
		const form = this.KhoDeNghiXuatKhoForm.controls;
		if (form["LYDOXUAT"].value == CONFIGURATION.OTHER_REASONS.key)
			return form["LYDOKHAC"].value ? form["LYDOKHAC"].value : "";
		let reason = this.arrReason.find(r => r.key == form["LYDOXUAT"].value);
		if (reason) return reason.value;
		return "";
	}
	// .............................................................
	// .. Hàm định dạng chuỗi
	fStr(a: any) { return a.toString(); }
	strEquals(a, b) { return this.fStr(a) === this.fStr(b); }
	// .............................................................
	// .. Thay đổi chứng từ kèm theo
	modifyChungTuKemTheo(data) {
		const form = this.KhoDeNghiXuatKhoForm.controls;
		const contentChungTu = form["TENSOCHUNGTU"];

		if (data) {
			contentChungTu.setValidators([Validators.required]);
			setTimeout(() => this.contentChungTu.first.nativeElement.focus(), 500);
		}
		else {
			contentChungTu.clearValidators();
			contentChungTu.setValue("");
		}
		contentChungTu.updateValueAndValidity();
		this.changeDetect.detectChanges();
	}
	// ..............................................................
	// .. Lấy thông tin ngày sản xuất theo hàng hóa
	getManufacturingDateFromIdHH(idhh) {
		let item = this.listId_HH.find(x => x.Id_HH == idhh);
		if (!item || item.length == 0) return [];
		return this.isNullEmptyArr(item.NgaySanXuat) ? [] : item.NgaySanXuat.split(",");
	}
	// .. Lấy thông tin hạn sử dụng theo hàng hóa
	getExpirationDateFromIdHH(idhh) {
		let item = this.listId_HH.find(x => x.Id_HH == idhh);
		if (!item || item.length == 0) return [];
		return this.isNullEmptyArr(item.HanSuDung) ? [] : item.HanSuDung.split(",");
	}
	// .. Lấy thông tin mã thùng TP theo hàng hóa
	getcontainerCodeFromIdHH(idhh) {
		let item = this.listId_HH.find(x => x.Id_HH == idhh);
		if (!item || item.length == 0) return [];
		return this.isNullEmptyArr(item.MaThungTP) ? [] : item.MaThungTP.split(",");
	}
	// ..............................................................
	// .. Valid sub form
	subFormValidation() {
		const subForm = this.KhoDeNghiXuatKhoSubForm;
		const subFormControl = subForm.controls;
		const invalidElements = this.el.nativeElement.querySelectorAll(".ng-invalid");

		// .. Check form
		if (subForm.invalid && invalidElements.length > 0) {
			for (var i = 0; i < invalidElements.length; i++) {
				const child = invalidElements[i];
				if (["INPUT", "MAT_SELECT"].includes(child.nodeName)) {
					const attributes = child.attributes.getNamedItem('"formcontrolname"').value;
					const element = subForm.get(attributes);
					if (element) {
						setTimeout(() => child.focus(), 100);
						break;
					}
				}
			}
			Object.keys(subFormControl).forEach((control) =>
				subFormControl[control].markAsTouched()
			);
			return false;
		}
		return true;
	}
	// ..............................................................
	// ... Lấy data hàng hóa đã chọn
	getSelectedProductDetails() {
		const hangHoaData = this.listId_HH.find(x => x.Id_HH == Number(this.selectId_HH));
		return hangHoaData || null;
	}
	// ... Fill data subform 
	mapFormControlDataToItem() {
		const form = this.KhoDeNghiXuatKhoForm.controls;
		const subForm = this.KhoDeNghiXuatKhoSubForm;
		const subFormControl = subForm.controls;
		const hangHoaData = this.getSelectedProductDetails();
		const khachHangData = this.listId_KH.find(x => x.IdKh == Number(this.selectedId_KH));
		const selectedCustomer = this.selectedId_KH || false;
		const doiTuongData = this.listObjTHCP.find(x => x.Id_HH == this.selectObjTHCP);
		const selectedDoiTuong = this.selectObjTHCP || false;
		const nameObjectTCP = selectedDoiTuong ? doiTuongData.MaHH + " - " + doiTuongData.TenHH : "";
		var data = this.dataTree.value && this.dataTree.value.length > 0 ? this.dataTree.value[0] : null;

		var item = new KhoDeNghiXuatKhoPageChiTiet();
		item.clear();
		item.IdHh = hangHoaData.Id_HH;
		item.MaHH = hangHoaData.MaHH;
		item.TenHH = hangHoaData.TenHH;
		item.QuyCach = hangHoaData.QuyCach;
		item.Dvt = hangHoaData.DVT;
		item.TenDvt = subFormControl["DVTQuiDoi"].value || hangHoaData.TenDVT;
		//item.TextQuiDoiDVT = this.soLuong + ',00 ' + hangHoaData.TenDVT;
		item.ListHH = this.mapUnitDataToItem();
		item.DvtQuiDoi = hangHoaData.DVT;
		item.SoLuongQuiDoi = +this.f_number(subFormControl["SoLuongQuiDoi"].value);
		item.Soluong = +this.f_number(subFormControl["SoLuongQuiDoi"].value);
		item.NgayCan = moment(subFormControl["NGAYCAN"].value).format("YYYY-MM-DD");
		item.MucDichSuDung = subFormControl["MUCDICHSUDUNG"].value;
		item.BPDN = +subFormControl["BPDN"].value;
		item.BPSD = +subFormControl["BPSD"].value; // Phòng ban sử d
		item.NewBPSD = subFormControl["DIVISION"].value ? +subFormControl["DIVISION"].value : 0; // Bộ phận sử dụng
		item.SoLo = subFormControl["SOLO"].value ? subFormControl["SOLO"].value : "";
		item.SLThucXuat = 0.0;
		item.SoMayArr = subFormControl["SOMAY"].value || [];
		item.SXSMArr = subFormControl["SOMEXE"].value || [];
		item.NSXArr = subFormControl["NSX"].value || [];
		item.HSDArr = subFormControl["HSD"].value || [];
		item.MaThungArr = subFormControl["MATHUNG"].value || [];
		item.TenBPDN = this.fetchDepartmentName(data, item.BPDN);
		item.TenBPSD = this.fetchDepartmentName(data, item.BPSD);
		item.NameNewBPSD = item.NewBPSD ? this.fetchDepartmentName(data, item.NewBPSD) : "";
		item.GhiChu = form["GHICHU"].value;
		item.IdKh = selectedCustomer ? this.selectedId_KH : null;
		item.MaKH = khachHangData ? khachHangData.Makh : "";
		item.TenKH = form["TenKhachHang"].value || "";
		item.DoiTuongTHCP = selectedDoiTuong ? Number(this.selectObjTHCP) : null;
		item.TenDoiTuongTHCP = nameObjectTCP;
		item.OptionsSoMay = this.listMachineCode;
		item.OptionsNSX = this.manufacturingDateList;
		item.OptionsHSD = this.expirationDateList;
		item.OptionsSMSX = this.batchQuantityList;
		item.OptionsMaThung = this.containerCodeList;

		if (!selectedCustomer)
			form["GHICHU"].setValue("");

		return item;
	}
	// ... Mapping đơn vị tính
	mapUnitDataToItem() {
		const hangHoaData = this.getSelectedProductDetails();
		var unitList = [];
		// ... Handle data
		if (hangHoaData != null) {
			if (hangHoaData.Dvt3 != null && hangHoaData.Dvt3 > 0) {
				unitList.push({
					DVT: hangHoaData.Dvt3,
					QuiDoiDVT: hangHoaData.QuiDoiDVT3,
					TenDVT: hangHoaData.TenDVT3
				});
			}
			if (hangHoaData.Dvt2 != null && hangHoaData.Dvt2 > 0) {
				unitList.push({
					DVT: hangHoaData.Dvt2,
					QuiDoiDVT: hangHoaData.QuiDoiDVT2,
					TenDVT: hangHoaData.TenDVT2
				});
			}
			unitList.push({
				DVT: hangHoaData.DVT,
				QuiDoiDVT: 1,
				TenDVT: hangHoaData.TenDVT
			});
		}
		unitList = unitList.filter(x => x.DVT);
		const listIdHH = unitList.map(x => x.DVT);
		unitList = unitList.filter((e, i) => listIdHH.indexOf(e.DVT) === i);
		return unitList;
	}
	// ... Mapping tên phòng ban
	fetchDepartmentName(data, id) {
		if (!data) return "";
		if (data.Id_PB == id) return data.TenPB;
		if (data.Childrens && data.Childrens.length > 0) {
			for (let child of data.Childrens) {
				let result = this.fetchDepartmentName(child, id);
				if (result) return result;
			}
		}
		return "";
	}
	// ..
	loadOrganizationStructureTree() {
		this._dynamicSequence.Get_CoCauToChuc().subscribe(res => {
			if (res.data && res.data.length > 0) {
				this.dataTree.next(res.data);
				this.orgStructureTree = res.data[0] ? this.balanceStructureTree(res.data[0], []) : [];
				this.ftrRequestDepartment.next([...this.orgStructureTree]);
				this.ftrUsingDepartment.next([...this.orgStructureTree]);
				//this.ftrUsingDivision.next([...this.orgStructureTree]);
				this.changeDetectView();
			}
		});
	}
	// ..............................................................
	balanceStructureTree(data, orgStructureTree: any[], level: number = 0) {
		if (!data) return;
		if (data) {
			if (level > 0) { // .. Loại bỏ Cty TNHH thực phẩm NFC
				orgStructureTree.push({
					Id_PB: data["Id_PB"],
					TenPB: data["TenPB"]
				});
			}
			if (data.Childrens && data.Childrens.length > 0) {
				data.Childrens.forEach(child => {
					this.balanceStructureTree(child, orgStructureTree, level + 1);
				})
			}
		}
		return orgStructureTree;
	}
	// .. Cập nhật các trường bắt buộc cho trường Phòng ban sử dụng
	updateRequiredFieldsForDepartmentUse() {
		const form = this.KhoDeNghiXuatKhoForm.controls;
		const subForm = this.KhoDeNghiXuatKhoSubForm.controls;
		if (CONFIGURATION.BPSD_REQUIRED.value == form["LOAIPHIEU"].value) {
			subForm[CONFIGURATION.BPSD_REQUIRED.key].setValidators([Validators.required]);
			this.requireDepartmentInUse.next(true);
		} else {
			subForm[CONFIGURATION.BPSD_REQUIRED.key].clearValidators();
			this.requireDepartmentInUse.next(false);
		}
		subForm[CONFIGURATION.BPSD_REQUIRED.key].updateValueAndValidity();
		this.changeDetect.detectChanges();
	}
	// ..............................................................
	// .. Cập nhật các trường bắt buộc cho trường đối tượng THCP
	updateRequiredFieldsForObjTHCP() {
		const form = this.KhoDeNghiXuatKhoForm.controls;
		const subForm = this.KhoDeNghiXuatKhoSubForm.controls;
		const FIELD_TYPE_OF_VOTE = "LOAIPHIEU";
		const FIELD_REASON = "LYDOXUAT";
		const selectedExportForUse = form[FIELD_TYPE_OF_VOTE].value == CONFIGURATION.BPSD_REQUIRED.value;
		const selectedReasonForProductionActivities = form[FIELD_REASON].value == CONFIGURATION.REASON_FOR_PRODUCTION_ACTIVITIES.key;
		if (selectedExportForUse && selectedReasonForProductionActivities)
			subForm[CONFIGURATION.REASON_FOR_PRODUCTION_ACTIVITIES.field].setValidators([Validators.required]);
		else
			subForm[CONFIGURATION.REASON_FOR_PRODUCTION_ACTIVITIES.field].clearValidators();
		subForm[CONFIGURATION.REASON_FOR_PRODUCTION_ACTIVITIES.field].updateValueAndValidity();
		this.changeDetect.detectChanges();
	}
	// ..............................................................
	// .. Cập nhật các trường bắt buộc theo đối tượng
	requiredFieldForObjTHCP() {
		const form = this.KhoDeNghiXuatKhoForm.controls;
		const FIELD_TYPE_OF_VOTE = "LOAIPHIEU";
		const FIELD_REASON = "LYDOXUAT";
		const selectedExportForUse = form[FIELD_TYPE_OF_VOTE].value == CONFIGURATION.BPSD_REQUIRED.value;
		const selectedReasonForProductionActivities = form[FIELD_REASON].value == CONFIGURATION.REASON_FOR_PRODUCTION_ACTIVITIES.key;
		return selectedExportForUse && selectedReasonForProductionActivities;
	}
	isRequiredField(field: string) {
		const form_field = this.KhoDeNghiXuatKhoSubForm.get(field);
		if (!form_field.validator) {
			return false;
		}
		const validator = form_field.validator({} as AbstractControl);
		return (validator && validator.required);
	}
	// .. Lấy danh sách nhà cung cấp
	async loadAllSuppliers() {
		const res = await this.commonService.listNCC().toPromise();
		if (res && res.data != null && res.status === 1) {
			this.suppliers = res.data;
			this.sumSuppliers = this.suppliers.length;
			this.filteredSuppliers.next(this.suppliers.slice());
		} else {
			this.filteredSuppliers.next([]);
		}
	}
	// .. Thực hiện set data sao khi chọn nhà cung cấp
	afterSelectSupplier(value: string) {
		const controls = this.KhoDeNghiXuatKhoForm.controls;
		this.suppliers.forEach(item => {
			if (item.Id_NCC === +value) {
				this.selectedSupplierId = Number(value);
				controls["SUPPLIER_CODE"].setValue(item.MaNCC);
				controls["SUPPLIER_NAME"].setValue(item.TenNCC);
				controls["SUPPLIER_CODE"].disable();
			}
		});
	}
	// .. Xóa data ncc đã chọn
	clearSelectSupplier(event: any) {
		const controls = this.KhoDeNghiXuatKhoForm.controls;
		this.selectedSupplierId = 0;
		controls["SUPPLIER_CODE"].enable();
		controls["SUPPLIER_CODE"].setValue('');
		controls["SUPPLIER_NAME"].setValue('');
		event.stopPropagation();
	}
	// .. Search data ncc
	searchSupplier(searchTmp: string = '') {
		if (!this.suppliers) {
			return;
		}
		if (searchTmp === '') {
			this.sumSuppliers = this.suppliers.length;
			this.filteredSuppliers.next(this.suppliers.slice());
			return;
		}
		else {
			searchTmp = searchTmp.toLowerCase().trim();
			const data = this.suppliers.filter(ts => ts.MaNCC.toLowerCase().includes(searchTmp) || ts.TenNCC.toLowerCase().includes(searchTmp));
			this.sumSuppliers = data.length;
			this.filteredSuppliers.next(data);
		}
	}
	// .. Nếu loại phiếu 'Xuất trả NCC và TH Khác' và lý do xuất 'Xuất trả NCC'
	toggleReturnTypeAndReasonForReuturnSupplier() {
		const form = this.KhoDeNghiXuatKhoForm.controls;
		const type = form["LOAIPHIEU"] ? form["LOAIPHIEU"].value : 0;
		const typeCode = this.fetchTypeCode(Number(type));
		const reason = form["LYDOXUAT"] ? form["LYDOXUAT"].value : "";
		return typeCode == CONFIGURATION.SUPPLIER_RETURN_TYPE && reason == CONFIGURATION.REASON_FOR_SUPPLIER_RETURN;
	}
	// .. Nếu loại phiếu 'Xuất trả NCC và TH Khác' và lý do xuất 'Khác'
	toggleReturnTypeAndAnotherReason() {
		const form = this.KhoDeNghiXuatKhoForm.controls;
		const type = form["LOAIPHIEU"] ? form["LOAIPHIEU"].value : 0;
		const typeCode = this.fetchTypeCode(Number(type));
		const reason = form["LYDOXUAT"] ? form["LYDOXUAT"].value : "";
		return typeCode == CONFIGURATION.SUPPLIER_RETURN_TYPE && reason == CONFIGURATION.OTHER_REASONS.key;
	}
	// .. Ẩn hiện khách hàng form
	toggleCustomerFormControl() {
		return this.toggleReturnTypeAndReasonForReuturnSupplier() || this.toggleReturnTypeAndAnotherReason();
	}
	fetchTypeCode(id) {
		if (!id || this.typeOptions.length == 0) return "";
		const selected = this.typeOptions.find(x => x.Id == id);
		return selected.Ma || "";
	}
	filterRequestDepartment() {
		const search = this.requestDepartmentFtrCtrl;
		if (!this.orgStructureTree) return;
		if (!search) {
			this.ftrRequestDepartment.next([...this.orgStructureTree]);
			return;
		}
		const lowerCaseSearch = search.toLowerCase().trim();
		this.ftrRequestDepartment.next(
			this.orgStructureTree.filter(ts =>
				ts.TenPB.toLowerCase().includes(lowerCaseSearch)
			)
		);
		this.changeDetectView();
	}
	filterUsingDepartment() {
		const search = this.usingDepartmentFtrCtrl;
		if (!this.orgStructureTree) return;
		if (!search) {
			this.ftrUsingDepartment.next([...this.orgStructureTree]);
			return;
		}
		const lowerCaseSearch = search.toLowerCase().trim();
		this.ftrUsingDepartment.next(
			this.orgStructureTree.filter(ts =>
				ts.TenPB.toLowerCase().includes(lowerCaseSearch)
			)
		);
		this.changeDetectView();
	}
	filterUsingDivision() {
		const search = this.usingDivisionFtrCtrl;
		if (!this.optionsDivision) return;
		if (!search) {
			this.ftrUsingDivision.next([...this.optionsDivision]);
			return;
		}
		const lowerCaseSearch = search.toLowerCase().trim();
		this.ftrUsingDivision.next(
			this.optionsDivision.filter(ts =>
				ts.TenPB.toLowerCase().includes(lowerCaseSearch)
			)
		);
		this.changeDetectView();
	}
	loadReasonExportDefaultFromExportType() {
		const formControl = this.KhoDeNghiXuatKhoForm.controls;
		const typeOption = this.typeOptions.find(x => x.Id == Number(formControl["LOAIPHIEU"].value));
		const typeOptionCode = typeOption.Ma;

		// .. Nếu phiếu là chỉnh sửa thì không load default
		if (this.KhoDeNghiXuatKhoItem && this.KhoDeNghiXuatKhoItem.IdDn > 0) return;

		// .. Nếu loại phiếu là 'Xuất sử dụng' thì mặc định lý do xuất 'Xuất cho hoạt động sản xuất'
		if (typeOptionCode == CONFIGURATION.EXPORT_TO_USE_TYPE) {
			formControl["LYDOXUAT"].setValue(CONFIGURATION.REASON_EXPORT_TO_PRODUCTION);
		}
		// .. Nếu loại phiếu là 'Xuất trả nhà cung cấp & TH khác' thì mặc định lý do xuất 'Xuất trả nhà cc'
		else if (typeOptionCode == CONFIGURATION.SUPPLIER_RETURN_TYPE) {
			formControl["LYDOXUAT"].setValue(CONFIGURATION.REASON_FOR_SUPPLIER_RETURN);
		}
		// .. Những loại phiếu khác thì mặc định lý do xuất 'Khác'
		else {
			formControl["LYDOXUAT"].setValue(CONFIGURATION.OTHER_REASONS.key);
		}
	}
	loadOptionsDropdownForDetails(isCopy: boolean = false){
		if (this.tmpChiTietKhoDeNghiXuatKho && this.tmpChiTietKhoDeNghiXuatKho.length > 0) {
			const productIdStr = this.tmpChiTietKhoDeNghiXuatKho.map(x => x.IdHh);
			this.commonService.top_list_of_merchandise_lite(productIdStr.join(",") + ",", productIdStr.length).subscribe(res => {
				if (res && res.data != null && res.status === 1) {
					const _data = res.data;
					this.tmpChiTietKhoDeNghiXuatKho.forEach(item => {
						const product = _data.find(x => x.Id_HH == item.IdHh);
						if (product) {
							item.OptionsSoMay 	= this.isNullEmptyArr(product.CodeMachines) ? [] : product.CodeMachines.split(",");
							item.OptionsNSX 	= this.isNullEmptyArr(product.NgaySanXuat) ? [] : product.NgaySanXuat.split(",");
							item.OptionsHSD 	= this.isNullEmptyArr(product.HanSuDung) ? [] : product.HanSuDung.split(",");
							item.OptionsSMSX 	= this.isNullEmptyArr(product.SoXeSoMe) ? [] : product.SoXeSoMe.split(",");
							item.OptionsMaThung = this.isNullEmptyArr(product.MaThungTP) ? [] : product.MaThungTP.split(",");
							if (isCopy) {
								item.Dvt 		= product.DVT;
								item.DvtQuiDoi 	= product.DVT;
								item.TenDvt 	= product.TenDVT;
							}
						}
					});
					this.changeDetectView();
				}
			});
		}
	}
	
	// Custom validator function for minimum value
	minValidator(minValue: number) {
		return (control: AbstractControl): ValidationErrors | null => {
			// Extract the value from the form control and convert it to a number
			const value = this.f_number(control.value ? control.value : 0);

			// Check if the value is less than the minimum value
			if (value !== null && value !== undefined && value < minValue) {
				// If the value is less than the minimum value, return a validation error object
				return { min: true, actualValue: value, minValue: minValue };
			}

			// If the value is greater than or equal to the minimum value, return null (no validation error)
			return null;
		};
	}

	// Hàm này được sử dụng để tải các tùy chọn phòng ban từ một giá trị nhất định
	loadDivisionOptions(value: string, setValueControl : boolean = true) {
		// Lấy các controls của form
		const form = this.KhoDeNghiXuatKhoSubForm.controls;

		// Chuyển đổi giá trị lựa chọn thành số nguyên
		const selectedOptionDepartment = Number(value);

		// Khởi tạo mảng chứa các tùy chọn cho dropdown
		let dropdownOptions: any[] = [];

		// Kiểm tra xem có dữ liệu trong dataTree và có phải là mảng không
		if (this.dataTree && Array.isArray(this.dataTree.value) && this.dataTree.value.length > 0) {
			// Tải dữ liệu cho dropdown từ giá trị id trong dataTree
			dropdownOptions = this.loadOptionTreeDataFromIdParam(this.dataTree.value[0], [], selectedOptionDepartment);

			// Kiểm tra xem dropdown có dữ liệu con hay không
			const hasSubData = dropdownOptions.length > 1;

			// Lọc các tùy chọn con nếu có
			const subData = dropdownOptions.filter(option => option.Id_PB != selectedOptionDepartment);

			// Cập nhật tùy chọn của dropdown dựa trên có dữ liệu con hay không
			this.optionsDivision = hasSubData ? subData : dropdownOptions;
			
			if (setValueControl) {
				// Cập nhật tùy chọn vào dropdown
				this.ftrUsingDivision.next([...this.optionsDivision]);

				// Nếu không có dữ liệu con, đặt giá trị cho control "NewBPSD"
				form["DIVISION"].setValue(!hasSubData ? dropdownOptions[0].Id_PB + '' : '');

				// Nếu có dữ liệu con, cập nhật validator cho control "BPSD"
				if (hasSubData) {
					form["DIVISION"].setValidators([Validators.required]);
					form["DIVISION"].updateValueAndValidity();
				}
			}
		}

		// Gọi hàm để cập nhật giao diện
		this.changeDetectView();
	}

	// Load tree from id node
	loadOptionTreeDataFromIdParam(data, ouput: any[], nodeID: number = 0) {
		if (!data) return;
		if (data) {
			var renewNodeId = false;
			if (data.Id_PB === nodeID) {
				ouput.push({
					Id_PB: data["Id_PB"],
					TenPB: data["TenPB"]
				});
				renewNodeId = true;
			}
			if (data.Childrens && data.Childrens.length > 0) {
				data.Childrens.forEach(child => {
					this.loadOptionTreeDataFromIdParam(child, ouput, renewNodeId ? child.Id_PB : nodeID);
				})
			}
		}
		return ouput;
	}
}
